angular.module("templates-niacs", ["browser/browser.html", "browser/cis.html", "browser/onboarding.html", "browser/unit.html", "browser/var-info-dialog.html", "directives/pane.html", "directives/paneset.html", "directives/static-pane-set.html", "partials/actions.html", "partials/dialogs/add-edit-custom-approach.html", "partials/dialogs/add-edit-custom-cis.html", "partials/dialogs/add-edit-custom-unit.html", "partials/dialogs/add-edit-monitor.html", "partials/dialogs/add-edit-tactic.html", "partials/dialogs/course-materials.html", "partials/dialogs/create-edit-project.html", "partials/dialogs/demo-projects.html", "partials/dialogs/impact-evidence.html", "partials/dialogs/print.html", "partials/dialogs/resources.html", "partials/dialogs/safe-confirm-dialog.html", "partials/dialogs/slow-down.html", "partials/dialogs/welcome.html", "partials/directives/climate-impact-statement-info.html", "partials/directives/climate-impacts.html", "partials/directives/font-awesome-action.html", "partials/directives/goal-objective-form.html", "partials/directives/navigation.html", "partials/directives/objective-evaluate.html", "partials/directives/project-debug.html", "partials/directives/project-details.html", "partials/directives/pw-goals.html", "partials/directives/recap-climate-impacts.html", "partials/directives/root-dashboard.html", "partials/directives/root-project.html", "partials/directives/root-strategies.html", "partials/directives/show-hide.html", "partials/directives/statement-form.html", "partials/directives/tactic-details.html", "partials/directives/title-panel.html", "partials/directives/unit-comments.html", "partials/directives/vulnerability-info.html", "partials/directives/vulnerability-plot.html", "partials/directives/vulnerability-sliders-ag.html", "partials/directives/vulnerability-sliders.html", "partials/evaluate.html", "partials/export.html", "partials/goals.html", "partials/homework.html", "partials/impacts.html", "partials/lms-export.html", "partials/lms/course-list.html", "partials/lms/course-listing.html", "partials/lms/course-materials.html", "partials/lms/edit-course-dialog.html", "partials/lms/edit-homework-dialog.html", "partials/lms/homework-export.html", "partials/lms/homework-questions.html", "partials/lms/homework-review-qual.html", "partials/lms/homework-review-text.html", "partials/lms/homework-review.html", "partials/lms/homework-stats.html", "partials/lms/hw-qual-answers.html", "partials/lms/hw-text-answer.html", "partials/lms/review-course-homework-dialog.html", "partials/lms/review-course-projects-dialog.html", "partials/monitor.html", "partials/overview.html", "partials/popovers/unit-info.html", "partials/recommendations.html", "partials/units.html", "partials/user-profile.html", "partials/vulnerability.html"]);

angular.module("browser/browser.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("browser/browser.html",
    "<div id=\"map-container\" class=\"browser\">\n" +
    "    <div id=\"tooltip\" class=\"label label-info\" ng-if=\"isState === false && tooltip\">Climate impacts for {{tooltip}}</div>\n" +
    "    <div id=\"tooltip\" class=\"label label-info\" ng-if=\"isState > 0 && tooltip\">National Climate Assessment climate impacts for {{tooltip}}</div>\n" +
    "    <a id=\"onboarding-link\" href ng-click=\"onboarding()\"> <fa-icon icon=\"question-circle\"></fa-icon></a>\n" +
    "    <div id=\"map-canvas\">\n" +
    "    </div>\n" +
    "    <div id=\"map-canvas-loading\" ng-if=\"loading\"><h2>Loading <fa-icon icon=\"spinner\" classes=\"fa-spin\"></fa-icon></h2></div>\n" +
    "    \n" +
    "</div>\n" +
    "<p class=\"browser-disclaimer\"><small>Information in this climate viewer is sourced from Ecosystem Vulnerability Assessments produced by the Northern Institute of Applied Climate Science, the National Climate Assessment produced by U.S. Global Change Research Program (USGCRP) and other sources. See citations for additional information.</small></p>");
}]);

angular.module("browser/cis.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("browser/cis.html",
    "<label>{{statement.label}} <a ng-if=\"up.isAdmin\" target=\"_blank\" ng-href=\"/node/{{statement.id}}/edit\"><i class=\"far fa-link\"></i></a></label>\n" +
    "<ul class=\"list-inline\" ng-if=\"statement.evidence || statement.agreement\">\n" +
    "    <li ng-if=\"statement.evidence\" class=\"evidence {{statement.evidence}}\">\n" +
    "        <label>Evidence</label> {{statement.evidence}}\n" +
    "    </li>\n" +
    "    <li ng-if=\"statement.agreement\" class=\"agreement {{statement.agreement}}\">\n" +
    "        <label>Agreement</label> {{statement.agreement}}\n" +
    "    </li>\n" +
    "</ul>\n" +
    "<p>{{statement.statement}}</p>\n" +
    "<ul class=\"list-unstyled\">\n" +
    "    <li ng-repeat=\"resource in (statement.resources)\" ng-bind-html=\"resource | niacsResourceDisplay\"></li>\n" +
    "    <li ng-if=\"statement.external_link && statement.external_link.length\" ng-repeat=\"external in statement.external_link\"><a target=\"external_evidence\" href=\"{{external.url}}\"><fa-icon icon=\"link\"></fa-icon> {{external.title}}</a></li>\n" +
    "    <li ng-if=\"statement.local_link && statement.local_link.length\" ng-repeat=\"local in statement.local_link\"><a target=\"local_evidence\" href=\"{{local.self}}\"><fa-icon icon=\"file-pdf\"></fa-icon> {{local.filename}}</a></li>\n" +
    "</ul>");
}]);

angular.module("browser/onboarding.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("browser/onboarding.html",
    "<div class=\"modal-content\">\n" +
    "    <div class=\"modal-body\">\n" +
    "        <fa-icon ng-click=\"dismiss()\" class=\"fa-1_5x niacs-right\" icon=\"times-circle\"></fa-icon>\n" +
    "        <img id=\"adaptimg\" src=\"/modules/custom/niacs_project_ui/img/climateimpacts2.gif\" alt=\".gif showing how to use the adaptation workbook.\" class=\"align-center\"/>\n" +
    "        <p>Click on an area of the country to see potential changes brought on by climate change.</p>\n" +
    "     </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("browser/unit.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("browser/unit.html",
    "<label>{{unit.label}} <a ng-if=\"up.isAdmin\" target=\"_blank\" ng-href=\"/node/unit.id/edit\"><i class=\"far fa-link\"></i></a></label>\n" +
    "<p>{{unit.description}}</p>\n" +
    "<ul class=\"list-unstyled\">\n" +
    "    <li ng-repeat=\"local in unit.local_link\"><a target=\"local_evidence\" href=\"{{local.self}}\"><fa-icon icon=\"file-pdf\"></fa-icon> {{local.filename}}</a></li>\n" +
    "    <li ng-repeat=\"external in unit.external_link\"><a target=\"external_evidence\" href=\"{{external.url}}\"><fa-icon icon=\"link\"></fa-icon> {{external.title}}</a></li>\n" +
    "</ul>\n" +
    "<div class=\"panel panel-default\" ng-if=\"unit.$climateImpacts.length\">\n" +
    "    <div class=\"panel-heading\" ng-click=\"unit.$showClimateImpacts = !unit.$showClimateImpacts\">\n" +
    "        <fa-icon classes=\"pull-right\" icon=\"chevron-{{unit.$showClimateImpacts ? 'down' : 'up'}}\"></fa-icon>\n" +
    "        {{unit.label}} climate impact statements\n" +
    "    </div>\n" +
    "    <div class=\"panel-body\" uib-collapse=\"!unit.$showClimateImpacts\">\n" +
    "        <div class=\"browser-cis\" ng-repeat=\"s in unit.$climateImpacts\" statement=\"s\"></div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "    ");
}]);

angular.module("browser/var-info-dialog.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("browser/var-info-dialog.html",
    "<div class=\"modal-header\">\n" +
    "    <fa-icon ng-click=\"dismiss()\" class=\"fa-1_5x niacs-right\" icon=\"times-circle\"></fa-icon>\n" +
    "    <h2>Climate Change Impacts for {{ vulnRegion.label }}</h2>\n" +
    "</div>\n" +
    "<div class=\"modal-body\">\n" +
    "    <p ng-if=\"vulnRegion.description && vulnRegion.description !== vulnRegion.label\">{{ vulnRegion.description }}</p>\n" +
    "\n" +
    "    <ul ng-if=\"vulnRegion.link || vulnRegion.video_link\" class=\"list-unstyled\">\n" +
    "        <li ng-if=\"vulnRegion.link\">\n" +
    "            <a ng-href=\"{{vulnRegion.link.url}}\"\n" +
    "                target=\"_blank\"\n" +
    "                alt=\"{{vulnRegion.link.title}}\"><fa-icon icon=\"link\"></fa-icon> {{vulnRegion.link.title||vulnRegion.link.url}}</a>\n" +
    "        </li>\n" +
    "        <li ng-if=\"vulnRegion.video_link\">\n" +
    "            <a ng-href=\"{{vulnRegion.video_link.url}}\"\n" +
    "                target=\"_blank\"\n" +
    "                alt=\"{{vulnRegion.video_link.title}}\"><fa-icon icon=\"link\"></fa-icon> {{vulnRegion.video_link.title||vulnRegion.video_link.url}}</a>\n" +
    "        </li>\n" +
    "    </ul>\n" +
    "\n" +
    "    <fa-icon ng-if=\"!tabs\" class=\"fa-3x\" classes=\"fa-spin\" icon=\"spinner\"></fa-icon>\n" +
    "    <uib-tabset ng-if=\"tabs\">\n" +
    "        <uib-tab ng-repeat=\"tab in tabs\" heading=\"{{tab.title}}\">\n" +
    "            <span ng-if=\"tab.impacts.length\">\n" +
    "                <div class=\"browser-cis\" ng-repeat=\"s in tab.impacts\" statement=\"s\"></div>\n" +
    "            </span>\n" +
    "            <span ng-if=\"tab.units.length\">\n" +
    "                <div class=\"browser-unit\" ng-repeat=\"unit in tab.units\" unit=\"unit\"></div>\n" +
    "            </span>\n" +
    "        </uib-tab>\n" +
    "    </uib-tabset>\n" +
    "</div>");
}]);

angular.module("directives/pane.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("directives/pane.html",
    "<li class=\"pane-heading\" ng-class=\"[{active: state.active},selectability]\" ng-click=\"select($event)\">\n" +
    "    <span pane-heading-transclude></span>\n" +
    "    <fa-icon ng-if=\"state.active\" icon=\"chevron-right\"></fa-icon>\n" +
    "</li>\n" +
    "");
}]);

angular.module("directives/paneset.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("directives/paneset.html",
    "<div class=\"container-fluid panes\">\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"pane headings\" ng-class=\"[openLeftCols]\">\n" +
    "            <div class=\"pane-contents\">\n" +
    "                <div class=\"pane-set-header\" ng-transclude=\"header\"></div>\n" +
    "                <ul class=\"inner list-unstyled\" ng-transclude></ul>\n" +
    "                <div class=\"pane-set-footer\" ng-transclude=\"footer\"></div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"pane contents closeable\" ng-class=\"[openRightCols]\">\n" +
    "            <a href class=\"contents-close\" ng-click=\"paneset.closeContents()\"><fa-icon icon=\"times\"></fa-icon></a>\n" +
    "            <div class=\"pane-contents\">\n" +
    "                <div class=\"inner\" ng-repeat=\"pane in paneset.panes\" ng-show=\"pane.state.active\" pane-content-transclude=\"pane\"></div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("directives/static-pane-set.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("directives/static-pane-set.html",
    "<div class=\"container-fluid panes static\">\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"pane headings\" ng-class=\"[$openLeftCols]\">\n" +
    "            <div class=\"pane-contents\">\n" +
    "                <div class=\"pane-set-header\" ng-transclude=\"header\"></div>\n" +
    "                <div class=\"inner\" ng-transclude=\"left\"></div>\n" +
    "                <div class=\"pane-set-footer\" ng-transclude=\"footer\"></div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"pane contents\" ng-class=\"[$openRightCols]\">\n" +
    "            <div class=\"pane-contents\">\n" +
    "                <div class=\"inner\" ng-transclude=\"right\"></div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("partials/actions.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("partials/actions.html",
    "<div ng-controller=\"ActionsCtrl\">\n" +
    "    <static-pane-set open-heading-cols=\"12\">\n" +
    "        <pane-set-header>\n" +
    "            <div class=\"pane-set-title\" title=\"Adaptation Tactics\"\n" +
    "                                        banner=\"{{project.tactics.length ? project.tactics.length : 0}} tactics\"\n" +
    "                                        status=\"{{project | step4Completeness}}\"></div>\n" +
    "        </pane-set-header>\n" +
    "        <pane-set-footer>\n" +
    "            <niacs-navigation></niacs-navigation>\n" +
    "        </pane-set-footer>\n" +
    "        <pane-set-left>\n" +
    "            <ul class=\"list-inline\">\n" +
    "                <li style=\"font-weight: bold;\">View a menu of adaptation strategies and approaches</li>\n" +
    "                <li ng-repeat=\"resource in strategyResources\">\n" +
    "                    <a class=\"btn btn-default big-secondary strategies-approaches\"\n" +
    "                        target=\"strategies-approaches\"\n" +
    "                        ng-href=\"/niacs-strategies/{{resource.getSourceAlias()}}\"><fa-icon icon=\"book\"></fa-icon> {{resource.getSourceTitle()}}</a>\n" +
    "                </li>\n" +
    "            </ul>\n" +
    "            <niacs-title-panel unique-id=\"g_o_recap\" type=\"recap-dockable\" panel-title=\"Review Goals and Objectives\" initial-state=\"closed\">\n" +
    "                  <table class=\"table table-condensed\">\n" +
    "                    <tbody ng-repeat=\"context in contexts\">\n" +
    "                        <tr class=\"active-tr\"\n" +
    "                            ng-click=\"context.$showGOOverview=!context.$showGOOverview\">\n" +
    "                            <td>\n" +
    "                                {{context | unitLabel:project}}\n" +
    "                            </td>\n" +
    "                            <td>{{context | goalObjectiveCount:false}}</td>\n" +
    "                        </tr>\n" +
    "                        <tr ng-show=\"context.$showGOOverview\">\n" +
    "                            <td colspan=\"2\">\n" +
    "                                <ul class=\"list-group goals\">\n" +
    "                                    <li class=\"list-group-item\" ng-if=\"!context.goals.length\"><h5>No Goals/Objectives</h5></li>\n" +
    "                                    <li class=\"list-group-item\" ng-repeat=\"goal in context.goals | inflate:project.goals:true\"><label>Goal:</label> {{(goal.description||goal.$description)  | mightBeEmpty}}\n" +
    "                                        <ul class=\"list-unstyled objectives\" ng-if=\"goal.objectives.length\">\n" +
    "                                          <li ng-repeat=\"objective in goal.objectives\"><label>Objective:</label> {{objective.description | mightBeEmpty}}<span ng-show=\"objective.timeframe\"> ({{objective.timeframe}})</span></li>\n" +
    "                                        </ul>\n" +
    "                                    </li>\n" +
    "                                </ul>\n" +
    "                            </td>\n" +
    "                        </tr>\n" +
    "                    </tbody>\n" +
    "                  </table>\n" +
    "            </niacs-title-panel>\n" +
    "\n" +
    "            <div ng-if=\"objectiveCount == 0\">Please define <a href=\"#goals/{{project.id}}\">Management goals and objectives</a>.</div>\n" +
    "\n" +
    "            <niacs-title-panel ng-repeat=\"tactic in project.tactics\"\n" +
    "                               unique-id=\"tactic.{{tactic.id}}\"\n" +
    "                               type=\"l2\"\n" +
    "                               add-classes=\"tactic-panel\"\n" +
    "                               panel-title=\"Tactic: {{tactic.tactical|mightBeEmpty:'&amp;lt;Empty&amp;gt;'}}\"\n" +
    "                               panel-banner-status=\"{{tactic.$refCount ? niacs.COMPLETE : niacs.INCOMPLETE}}\"\n" +
    "                               panel-banner=\"Applicable to {{tactic.$refCount ? tactic.$refCount : 0}} objectives\"\n" +
    "                               icons=\"tactic.$controls\">\n" +
    "            <form role=\"form\">\n" +
    "              <tactic-details tactic=\"tactic\"></tactic-details>\n" +
    "\n" +
    "              <span ng-init=\"initTacticRefVisibility(tactic)\">\n" +
    "                <div class=\"row\">\n" +
    "                  <div class=\"col-xs-11\"><label>Does this tactic apply to these objectives?</label></div>\n" +
    "                  <div class=\"col-xs-1\">\n" +
    "                      <toggle on=\"{{tacticRefVisibility[tactic.id]}}\"\n" +
    "                              classes=\"pull-right\"\n" +
    "                              on-toggle=\"tacticRefVisibility[tactic.id]=!tacticRefVisibility[tactic.id]\"\n" +
    "                              on-tooltip=\"Show All Objectives\"\n" +
    "                              off-tooltip=\"Show Only Applicable Objectives\"></toggle>\n" +
    "                  </div>\n" +
    "                </div>\n" +
    "                <span ng-repeat=\"goal in goals | inflate:project.goals:true\">\n" +
    "                  <span ng-repeat=\"objective in goal.objectives\" ng-init=\"tacticRef=getTacticRef(objective,tactic);\">\n" +
    "                  <div class=\"well tactic-objective-well\" ng-if=\"!tacticRefVisibility[tactic.id] || tacticRef.applicable\">\n" +
    "                    <div class=\"row\">\n" +
    "                      <div class=\"col-xs-2 tactic-controls\">\n" +
    "                        <div class=\"is-appplicable btn-group\">\n" +
    "                            <label class=\"no btn btn-default btn-xs\" ng-model=\"tacticRef.applicable\" uib-btn-radio=\"false\" ng-change=\"changeApplicability(objective,tacticRef)\"></label>\n" +
    "                            <label class=\"yes btn btn-default btn-xs\" ng-model=\"tacticRef.applicable\" uib-btn-radio=\"true\" ng-change=\"changeApplicability(objective,tacticRef)\"></label>\n" +
    "                        </div>\n" +
    "                      </div>\n" +
    "                      <div class=\"col-xs-10\">\n" +
    "                        <a href class=\"not-a-link tactic-goal-info\"\n" +
    "                             popover-title=\"Management Topic: {{objective.$sourceLabel||'?'}}\"\n" +
    "                             uib-popover=\"Goal: {{goal.description||goal.$description}}\"\n" +
    "                             popover-placement=\"bottom\"\n" +
    "                             popover-trigger=\"'mouseenter'\">\n" +
    "                          <label>Management Topic:</label> {{objective.$sourceLabel||'?'}} <label>&gt; Goal:</label> {{(goal.description||goal.$description) | ellipses}}\n" +
    "                        </a>\n" +
    "                        <div class=\"tactic-objective-info\">\n" +
    "                          <label>Objective:</label> {{objective.description}}\n" +
    "                        </div>\n" +
    "                      </div>\n" +
    "                    </div>\n" +
    "                  </div>\n" +
    "                  </span>\n" +
    "                </span>\n" +
    "              </span>\n" +
    "          </form>\n" +
    "          </niacs-title-panel>\n" +
    "          <div class=\"action-trailer\">\n" +
    "              <button class=\"btn btn-default niacs-btn-action niacs-right\" ng-click=\"addTactic()\">Add {{project.tactics.length ? 'Another' : 'A'}} Tactic <fa-icon icon=\"plus-circle\"></fa-icon></button>\n" +
    "          </div>\n" +
    "        </pane-set-left>\n" +
    "    </static-pane-set>\n" +
    "</div>\n" +
    "");
}]);

angular.module("partials/dialogs/add-edit-custom-approach.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("partials/dialogs/add-edit-custom-approach.html",
    "<div class=\"modal-header\">\n" +
    "    <font-awesome-action action=\"dismiss()\" icon=\"times-circle\" add-classes=\"niacs-right\" size=\"1_5\"></font-awesome-action>\n" +
    "    Custom Approach\n" +
    "    <p>{{strategy.name}}</p>\n" +
    "  </div>\n" +
    "  <div class=\"modal-body\">\n" +
    "    <form name=\"theApproachForm\">\n" +
    "      <div class=\"row\">\n" +
    "        <textarea custom-placeholder=\"APPROACH_CUSTOM_PLACEHOLDER\"\n" +
    "                  ng-model=\"approach.name\"\n" +
    "                  class=\"msd-elastic\" ng-class=\"{empty: !approach.name}\"\n" +
    "                  required></textarea>\n" +
    "      </div>\n" +
    "      <button class=\"btn btn-default niacs-btn-action btn-block\" ng-click=\"save()\" ng-disabled=\"theApproachForm.$invalid\">Save</button>\n" +
    "    </form>\n" +
    "  </div>\n" +
    "");
}]);

angular.module("partials/dialogs/add-edit-custom-cis.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("partials/dialogs/add-edit-custom-cis.html",
    "<div class=\"modal-header\">\n" +
    "    <font-awesome-action action=\"dismiss()\" icon=\"times-circle\" add-classes=\"niacs-right\" size=\"1_5\"></font-awesome-action>\n" +
    "    {{unit?(unit.label||unit.$label):'Regional'}} Climate Impact Statement\n" +
    "  </div>\n" +
    "  <div class=\"modal-body\">\n" +
    "    <form name=\"theStatementForm\">\n" +
    "      <div class=\"row\">\n" +
    "        <input style=\"width:100%\" type=\"text\" custom-placeholder=\"PLACEHOLDER_CUSTOM_CLIMATE_IMPACT_STATEMENT\"\n" +
    "               ng-model=\"theStatement.label\" required />\n" +
    "      </div>\n" +
    "      <div class=\"row\">\n" +
    "        <textarea custom-placeholder=\"PLACEHOLDER_CUSTOM_CLIMATE_IMPACT_COMMENTS\"\n" +
    "                  class=\"msd-elastic\" ng-class=\"{empty: !theStatement.statement}\"\n" +
    "                  ng-model=\"theStatement.statement\" required></textarea>\n" +
    "      </div>\n" +
    "\n" +
    "      <!-- iterate over theStatement.external_link -->\n" +
    "      <div class=\"row\" ng-repeat=\"link in theStatement.external_link\">\n" +
    "        <div class=\"col-md-1\"><fa-icon class=\"fa-1_5x\" icon=\"link\"></fa-icon></div>\n" +
    "        <div class=\"col-md-4\"><input style=\"width: 100%\" type=\"text\" ng-model=\"link.title\" placeholder=\"Link Title\" required /></div>\n" +
    "        <div class=\"col-md-6\"><input style=\"width: 100%\" type=\"url\" ng-model=\"link.url\" placeholder=\"Link to Evidence\" required /></div>\n" +
    "        <div class=\"col-md-1\">\n" +
    "          <font-awesome-action icon=\"times-circle\"\n" +
    "                             action=\"removeLink(link)\" icon-tooltip=\"Remove link\"></font-awesome-action>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "      <button class=\"btn btn-default niacs-btn-action secondary niacs-right\"\n" +
    "              style=\"margin-bottom: 15px;\"\n" +
    "              ng-click=\"addLink()\">Add {{theStatement.external_link.length ? 'more ' : ''}}evidence <fa-icon icon=\"plus-circle\"></fa-icon></button>\n" +
    "\n" +
    "      <button class=\"btn btn-default niacs-btn-action btn-block\" ng-click=\"save()\" ng-disabled=\"theStatementForm.$invalid\">Save</button>\n" +
    "    </form>\n" +
    "  </div>\n" +
    "");
}]);

angular.module("partials/dialogs/add-edit-custom-unit.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("partials/dialogs/add-edit-custom-unit.html",
    "<div class=\"modal-header\">\n" +
    "    <font-awesome-action action=\"dismiss()\" icon=\"times-circle\" add-classes=\"niacs-right\" size=\"1_5\"></font-awesome-action>\n" +
    "    Custom Management Topic\n" +
    "  </div>\n" +
    "  <div class=\"modal-body\">\n" +
    "    <form name=\"theUnitForm\">\n" +
    "      <div class=\"row\">\n" +
    "        <input type=\"text\" ng-model=\"unit.label\" placeholder=\"Title\" required>\n" +
    "      </div>\n" +
    "      <div class=\"row\">\n" +
    "        <textarea custom-placeholder=\"CUSTOM_UNIT_DESCRIPTION_PLACEHOLDER\"\n" +
    "                  ng-model=\"unit.description\"\n" +
    "                  class=\"msd-elastic\" ng-class=\"{empty: !unit.description}\"\n" +
    "                  required></textarea>\n" +
    "      </div>\n" +
    "\n" +
    "      <!-- iterate over unit.external_link -->\n" +
    "      <div class=\"row\" ng-repeat=\"link in unit.external_link\">\n" +
    "        <div class=\"col-md-1\"><fa-icon class=\"fa-1_5x\" icon=\"link\"></fa-icon></div>\n" +
    "        <div class=\"col-md-4\"><input style=\"width: 100%\" type=\"text\" ng-model=\"link.title\" placeholder=\"Link Title\" required /></div>\n" +
    "        <div class=\"col-md-6\"><input style=\"width: 100%\" type=\"url\" ng-model=\"link.url\" placeholder=\"Link Value\" required /></div>\n" +
    "        <div class=\"col-md-1\">\n" +
    "          <font-awesome-action icon=\"times-circle\"\n" +
    "                             action=\"removeLink(link)\" icon-tooltip=\"Remove link\"></font-awesome-action>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "      <button class=\"btn btn-default niacs-btn-action secondary niacs-right\"\n" +
    "              style=\"margin-bottom: 15px;\"\n" +
    "              ng-click=\"addLink()\">Add {{unit.external_link.length ? 'another' : 'a'}} link <fa-icon icon=\"plus-circle\"></fa-icon></button>\n" +
    "\n" +
    "      <button class=\"btn btn-default niacs-btn-action btn-block\" ng-click=\"save()\" ng-disabled=\"theUnitForm.$invalid\">Save</button>\n" +
    "    </form>\n" +
    "  </div>\n" +
    "");
}]);

angular.module("partials/dialogs/add-edit-monitor.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("partials/dialogs/add-edit-monitor.html",
    "<div class=\"modal-header\">\n" +
    "    <font-awesome-action action=\"dismiss()\" icon=\"times-circle\" add-classes=\"niacs-right\" size=\"1_5\"></font-awesome-action>\n" +
    "    Monitoring Variable\n" +
    "  </div>\n" +
    "  <div class=\"modal-body\">\n" +
    "    <form name=\"theMonitorForm\">\n" +
    "\n" +
    "      <div class=\"row\">\n" +
    "        <div class=\"col-xs-12\">\n" +
    "          <div class=\"form-group\">\n" +
    "            <label>Monitoring Variable</label>\n" +
    "            <div>\n" +
    "            <textarea custom-placeholder=\"PLACEHOLDER_MONITOR_VAR\"\n" +
    "                      ng-model=\"monitor.vari\"\n" +
    "                      class=\"msd-elastic\" ng-class=\"{empty: !monitor.vari}\"\n" +
    "                      required></textarea>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"row\">\n" +
    "        <div class=\"col-xs-12\">\n" +
    "          <div class=\"form-group\">\n" +
    "            <label>Criteria For Evaluation</label>\n" +
    "            <div>\n" +
    "            <textarea custom-placeholder=\"PLACEHOLDER_MONITOR_CRITERIA\"\n" +
    "                      ng-model=\"monitor.crit\"\n" +
    "                      class=\"msd-elastic\" ng-class=\"{empty: !monitor.crit}\"></textarea>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "\n" +
    "      <div class=\"row\">\n" +
    "        <div class=\"col-xs-12\">\n" +
    "          <div class=\"form-group\">\n" +
    "            <label>Monitoring Implementation</label>\n" +
    "            <div>\n" +
    "            <textarea custom-placeholder=\"PLACEHOLDER_MONITOR_IMPL\"\n" +
    "                      ng-model=\"monitor.impl\"\n" +
    "                      class=\"msd-elastic\" ng-class=\"{empty: !monitor.impl}\"></textarea>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "\n" +
    "      <button class=\"btn btn-default niacs-btn-action btn-block\" ng-click=\"save()\" ng-disabled=\"theMonitorForm.$invalid\">Save</button>\n" +
    "    </form>\n" +
    "  </div>\n" +
    "");
}]);

angular.module("partials/dialogs/add-edit-tactic.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("partials/dialogs/add-edit-tactic.html",
    "<div class=\"modal-header\">\n" +
    "<font-awesome-action action=\"dismiss()\" icon=\"times-circle\" add-classes=\"niacs-right\" size=\"1_5\"></font-awesome-action>\n" +
    "{{tactic.id ? 'Edit' : 'New'}} Tactic\n" +
    "</div>\n" +
    "<div class=\"modal-body\">\n" +
    "    <!--pre>{{tactic.approaches | json}}</pre-->\n" +
    "      <form role=\"form\" name=\"tacticForm\">\n" +
    "\n" +
    "        <div class=\"container-fluid\">\n" +
    "          <div class=\"row\" ng-repeat=\"approach in tactic.approaches\">\n" +
    "            <div class=\"col-xs-3\">\n" +
    "                <div class=\"form-group\">\n" +
    "                    <a ng-if=\"approach.$sector\"\n" +
    "                        target=\"strategies-approaches\" ng-href=\"{{sectorMenuUrl(approach.$sector)}}\"\n" +
    "                        uib-tooltip=\"Link to a menu of adaptation Strategies and Approaches.\"\n" +
    "                        tooltip-placement=\"top\"\n" +
    "                        tooltip-trigger=\"mouseenter\"\n" +
    "                        tooltip-append-to-body=\"true\"><fa-icon icon=\"book\"></fa-icon></a>&nbsp;&nbsp;\n" +
    "                    <label for=\"sector\">Sector</label>\n" +
    "                    <select name=\"sector\" class=\"form-control\" ng-options=\"o.getSource() as o.getSourceTitle() for o in sectors\" ng-model=\"approach.$sector\" ng-change=\"sectorChanged(approach)\"></select>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"col-xs-4\">\n" +
    "              <div class=\"form-group\">\n" +
    "                <label for=\"strategy\">Strategy</label>\n" +
    "                <select name=\"strategy\" class=\"form-control\" ng-options=\"o.id as o.name for o in approach.$strategies\" ng-model=\"approach.strategy\" ng-change=\"strategyChanged(approach)\"></select>\n" +
    "              </div>\n" +
    "            </div>\n" +
    "            <div class=\"col-xs-{{$first ? '5' : '4'}}\">\n" +
    "              <div class=\"form-group\">\n" +
    "                <label for=\"approach\">Approach</label>\n" +
    "                <select name=\"approach\" class=\"form-control\" ng-options=\"o.id as o.name for o in getApproaches(approach)\" ng-model=\"approach.approach\"></select>\n" +
    "              </div>\n" +
    "            </div>\n" +
    "            <div class=\"col-xs-1\" ng-if=\"!$first\">\n" +
    "              <div class=\"form-group\">\n" +
    "                <label style=\"margin-top: 30px;\">&nbsp;</label>\n" +
    "                <font-awesome-action  icon=\"times-circle\" action=\"removeApproach($index)\" icon-tooltip=\"Remove Strategy/Approach\"></font-awesome-action>\n" +
    "              </div>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "          <div class=\"row\">\n" +
    "            <div class=\"col-xs-12\">\n" +
    "              <button class=\"btn btn-default niacs-btn-action secondary niacs-right\"\n" +
    "                  style=\"margin: 10px 0px;\"\n" +
    "                  ng-click=\"addApproach()\">Add Strategy/Approach <fa-icon icon=\"plus-circle\"></fa-icon></button>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "\n" +
    "          <div class=\"row\">\n" +
    "            <div class=\"col-xs-9\">\n" +
    "              <div class=\"form-group\">\n" +
    "                <label>Tactical Details</label>\n" +
    "                <textarea custom-placeholder=\"APPROACH_TACTICAL_PLACEHOLDER\"\n" +
    "                          ng-model=\"tactic.tactical\"\n" +
    "                          class=\"msd-elastic\" ng-class=\"{empty: !tactic.tactical}\" required></textarea>\n" +
    "              </div>\n" +
    "            </div>\n" +
    "            <div class=\"col-xs-3\">\n" +
    "              <div class=\"form-group\">\n" +
    "                <label>Timeframe</label><info-icon key=\"TOOLTIP_TACTIC_TIMEFRAME\" icon-color=\"black\" placement=\"left\"></info-icon>\n" +
    "                <input type=\"text\" placeholder=\"Time Frame\" style=\"width:100%;\"\n" +
    "                       ng-model=\"tactic.timeframe\" />\n" +
    "              </div>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "          <div class=\"row\">\n" +
    "            <div class=\"col-xs-9\">\n" +
    "              <div class=\"form-group\">\n" +
    "                <label>Benefits</label>\n" +
    "                <textarea custom-placeholder=\"APPROACH_BENEFITS_PLACEHOLDER\"\n" +
    "                          ng-model=\"tactic.benefits\"\n" +
    "                          class=\"msd-elastic\" ng-class=\"{empty: !tactic.benefits}\"></textarea>\n" +
    "              </div>\n" +
    "            </div>\n" +
    "            <div class=\"col-xs-3\">\n" +
    "              <div class=\"form-group\">\n" +
    "                <label for=\"practicability\">Practicability</label><info-icon key=\"TOOLTIP_TACTIC_PRACTICABILITY\" icon-color=\"black\" placement=\"left\"></info-icon>\n" +
    "                <select name=\"practicability\" class=\"form-control\" ng-options=\"o.id as o.label for o in vocab_tactic_practicability\" ng-model=\"tactic.practicability\"></select>\n" +
    "              </div>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "          <div class=\"row\">\n" +
    "            <div class=\"col-xs-12\">\n" +
    "              <div class=\"form-group\">\n" +
    "                <label>Drawbacks and Barriers</label>\n" +
    "                <textarea custom-placeholder=\"APPROACH_DRAWBACKS_PLACEHOLDER\"\n" +
    "                          ng-model=\"tactic.drawbacks\"\n" +
    "                          class=\"msd-elastic\" ng-class=\"{empty: !tactic.drawbacks}\"></textarea>\n" +
    "              </div>\n" +
    "            </div>\n" +
    "            <div class=\"col-xs-3\">&nbsp;</div>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "\n" +
    "        <button class=\"btn btn-default niacs-btn-action btn-block\" ng-click=\"save()\" ng-disabled=\"tacticForm.$invalid || !validApproaches()\">Save</button>\n" +
    "    </form>\n" +
    "</div>\n" +
    "");
}]);

angular.module("partials/dialogs/course-materials.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("partials/dialogs/course-materials.html",
    "<div class=\"modal-header cleafix\">\n" +
    "    <font-awesome-action action=\"dismiss()\" icon=\"times-circle\" add-classes=\"niacs-right\" size=\"1_5\"></font-awesome-action>\n" +
    "    <h2>{{offering.title}} :: Course Materials</h2>\n" +
    "  </div>\n" +
    "  <div class=\"modal-body\">\n" +
    "    <course-offering-materials offering=\"offering\"></course-offering-materials>\n" +
    "  </div>\n" +
    "");
}]);

angular.module("partials/dialogs/create-edit-project.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("partials/dialogs/create-edit-project.html",
    "<form class=\"form-horizontal\" role=\"form\" name=\"createEditProjectForm\" id=\"createEditProjectForm\">\n" +
    "<niacs-title-panel unique-id=\"project.map\" panel-title=\"Location\" no-show-hide=\"true\">\n" +
    "  <div id=\"map-instructions\" ng-if=\"!project.id\">\n" +
    "    <custom-html key=\"MAP_INSTRUCTIONS\"></custom-html>\n" +
    "  </div>\n" +
    "  <div id=\"map-container\">\n" +
    "    <div id=\"map-canvas\"></div>\n" +
    "    <div id=\"map-canvas-loading\" ng-if=\"loadStatus\"><h2>Loading <fa-icon icon=\"spinner\" classes=\"fa-spin\"></fa-icon></h2></div>\n" +
    "  </div>\n" +
    "</niacs-title-panel>\n" +
    "<niacs-title-panel unique-id=\"project.create.edit\" panel-title=\"Details\">\n" +
    "          <div class=\"form-group\">\n" +
    "            <label for=\"inputName\" class=\"col-sm-2 control-label\">Name</label>\n" +
    "            <div class=\"col-sm-10\">\n" +
    "              <input type=\"text\" class=\"form-control\" id=\"inputName\" custom-placeholder=\"PROPERTY_NAME_PLACEHOLDER\" ng-model=\"project.label\" required>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "\n" +
    "          <div class=\"form-group\">\n" +
    "            <label for=\"inputDescription\" class=\"col-sm-2 control-label\">Description</label>\n" +
    "            <div class=\"col-sm-10\">\n" +
    "              <textarea ng-model=\"project.description\"\n" +
    "                        class=\"form-control msd-elastic\" ng-class=\"{empty: !project.description}\"\n" +
    "                        custom-placeholder=\"PROPERTY_DESCRIPTION_PLACEHOLDER\"></textarea>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "\n" +
    "\n" +
    "\n" +
    "          <div class=\"form-group\" style=\"position: relative;\">\n" +
    "            <label for=\"inputAcres\" class=\"col-sm-2 control-label\">Acres</label>\n" +
    "            <div class=\"col-sm-3\">\n" +
    "              <div style=\"display: inline-block;\">\n" +
    "                <input type=\"text\" class=\"form-control\" id=\"inputAcres\" min=\"1\" custom-placeholder=\"ACRES_PLACEHOLDER\" ng-model=\"project.acres\" number-with-commas>\n" +
    "              </div>\n" +
    "            </div>\n" +
    "            <div ng-if=\"status_warning\" class=\"col-xs-7\" style=\"position: absolute; right: 0px;\">\n" +
    "              <p class=\"text-danger\">{{status_warning}}</p>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "\n" +
    "          <div class=\"form-group\">\n" +
    "            <label for=\"inputSize\" class=\"col-sm-2 control-label\">Size</label>\n" +
    "            <div class=\"col-sm-3\">\n" +
    "              <div style=\"display: inline-block;\">\n" +
    "                <input type=\"text\" class=\"form-control\" id=\"inputSize\" min=\"1\" custom-placeholder=\"SIZE_PLACEHOLDER\" ng-model=\"project.size\">\n" +
    "              </div>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "\n" +
    "          <div class=\"form-group\">\n" +
    "            <label for=\"inputOwnership\" class=\"col-sm-2 control-label\">Ownership</label>\n" +
    "            <div class=\"col-sm-10\">\n" +
    "              <select name=\"inputOwnership\" class=\"form-control\" ng-options=\"o.id as o.label for o in vocab_ownership\" ng-model=\"project.ownership\"></select>\n" +
    "            </div>\n" +
    "          </div>\n" +
    "\n" +
    "          <div ng-if=\"!hideStrategies\" class=\"form-group strategy-sources\">\n" +
    "              <label for=\"strategySources\" class=\"col-sm-2 control-label\">Project Type</label>\n" +
    "              <div class=\"col-sm-10 radio\">\n" +
    "                  <label ng-if=\"!project.id\" ng-repeat=\"source in strategySources\" class=\"radio-inline\">\n" +
    "                    <input  type=\"radio\"\n" +
    "                            name=\"strategySources\",\n" +
    "                            value=\"{{source.getSource()}}\"\n" +
    "                            ng-model=\"project.strategy_sources[0]\" /> {{source.getSourceTitle()}}</label>\n" +
    "                    <label ng-if=\"project.id\">{{strategySourceMap[project.strategy_sources[0]].getSourceTitle()}}</label>\n" +
    "                </div>\n" +
    "          </div>\n" +
    "\n" +
    "          <input type=\"hidden\" class=\"form-control\" id=\"inputLatitude\" ng-model=\"project.lat\" required>\n" +
    "          <input type=\"hidden\" class=\"form-control\" id=\"inputLongitude\" ng-model=\"project.lon\" required>\n" +
    "          <input type=\"hidden\" class=\"form-control\" id=\"inputState\" ng-model=\"project.state\">\n" +
    "          <input type=\"hidden\" class=\"form-control\" id=\"inputNiacsRegion\" ng-model=\"project.vuln_region\">\n" +
    "          <!-- the customer asked that this information be removed from the view, including it here only conditionally since\n" +
    "               the info is potentially interesting from a debug perspective.  This info can be toggled on/off by typing\n" +
    "               CTRL+SHIFT+D -->\n" +
    "          <div class=\"row\" style=\"margin-left: 35px;\" ng-if=\"niacs.DEBUG\">\n" +
    "            <div class=\"col-md-3\">\n" +
    "              <div><label>Latitude:</label> {{project.lat}}</div>\n" +
    "            </div>\n" +
    "            <div class=\"col-md-3\">\n" +
    "              <div><label>Longitude:</label> {{project.lon}}</div>\n" +
    "            </div>\n" +
    "\n" +
    "            <div class=\"col-md-3\">\n" +
    "              <div><label>State:</label> {{project.state | niacsTerm:vocab_state}}</div>\n" +
    "            </div>\n" +
    "            <div class=\"col-md-3\">\n" +
    "              <div><label>Region:</label> {{project.$vuln_region.label}}</div>\n" +
    "            </div>\n" +
    "\n" +
    "          </div>\n" +
    "</niacs-title-panel>\n" +
    "\n" +
    "<div class=\"modal-footer\">\n" +
    "   <button class=\"btn btn-default\" ng-click=\"cancel()\">Cancel</button>\n" +
    "   <button class=\"btn btn-default\" ng-disabled=\"createEditProjectForm.$invalid\" ng-click=\"ok()\">OK</button>\n" +
    "</div>\n" +
    "</form>\n" +
    "");
}]);

angular.module("partials/dialogs/demo-projects.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("partials/dialogs/demo-projects.html",
    "<div class=\"modal-header cleafix\">\n" +
    "  <font-awesome-action action=\"dismiss()\" icon=\"times-circle\" add-classes=\"niacs-right\" size=\"1_5\"></font-awesome-action>\n" +
    "  <h2>Demonstration Projects</h2>\n" +
    "</div>\n" +
    "<div class=\"modal-body\">\n" +
    "    <div class=\"container-fluid\">\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"col-xs-6 form-group\">\n" +
    "                <label for=\"ownershipCriteria\">Ownership</label>\n" +
    "                <select class=\"form-control\" name=\"ownershipCriteria\" ng-model=\"queryInput.ownerships\" ng-options=\"o for o in validCriteria.ownerships\">\n" +
    "                    <option value=\"\">Any ownership</option>\n" +
    "                </select>\n" +
    "            </div>\n" +
    "            <div class=\"col-xs-6 form-group\">\n" +
    "                <label for=\"locationCriteria\">Location</label>\n" +
    "                <select class=\"form-control\" name=\"locationCriteria\" ng-model=\"queryInput.states\" ng-options=\"s for s in validCriteria.states\">\n" +
    "                    <option value=\"\">Any location</option>\n" +
    "                </select>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"row\" ng-show=\"response.meta.total\">\n" +
    "            <div class=\"col-xs-6\">\n" +
    "                <p>Displaying {{demoProjectsUrl | topSkipUrlToRange:response.meta.total}} demo projects</p>\n" +
    "            </div>\n" +
    "            <div class=\"col-xs-6\" ng-show=\"response.meta.total > response.list.length\">\n" +
    "                <div class=\"btn-group pull-right\">\n" +
    "                    <button type=\"button\" class=\"btn btn-default previous\" ng-disabled=\"!response.links.prev\" ng-click=\"demoProjectsUrl = response.links.prev;\"><fa-icon icon=\"chevron-left\"></fa-icon>Previous page</button>\n" +
    "                    <button type=\"button\" class=\"btn btn-default next\" ng-disabled=\"!response.links.next\" ng-click=\"demoProjectsUrl = response.links.next;\">Next page <fa-icon icon=\"chevron-right\"></fa-icon></button>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <br />\n" +
    "    <div class=\"well text-primary\" ng-if=\"response.list.length\">These are all projects that have used the adaptation workbook in real life.  You can filter these real world examples by ownership type and location.</div>\n" +
    "    <div class=\"well text-warning\" ng-if=\"response.list.length === 0\">No demonstration projects appear to match the current criteria. <a href ng-click=\"allProjects()\">Browse all demonstration projects.</a></div>\n" +
    "    <div class=\"demo-project clearfix\" ng-repeat=\"project in response.list\">\n" +
    "        <img ng-if=\"project.area_photo.url_medium\" ng-src=\"{{project.area_photo.url_medium}}\" class=\"mg-responsive pull-right\"\n" +
    "            alt=\"{{project.area_photo.alt||project.area_photo.title}}\" title=\"{{project.area_photo.title||project.area_photo.alt}}\" />\n" +
    "        <h3><a target=\"demo_projects\" ng-href=\"{{project.links.self}}\" alt=\"{{project.title}}\" title=\"{{project.title}}\">{{project.title}}</a>&nbsp;<span ng-if=\"project.ownerships.length\">{{project.ownerships.join(', ')}}</span><span ng-if=\"project.states.length\"><span ng-if=\"project.ownerships.length\">, </span>{{project.states.join(', ')}}</span></h3>\n" +
    "        <p>{{project.summary}}</p>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("partials/dialogs/impact-evidence.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("partials/dialogs/impact-evidence.html",
    "<div class=\"modal-header\">\n" +
    "    <font-awesome-action action=\"dismiss()\" icon=\"times-circle\" add-classes=\"niacs-right\" size=\"1_5\"></font-awesome-action>\n" +
    "    <niacs-cis-info statement=\"theInfo\"></niacs-cis-info>\n" +
    "  </div>\n" +
    "  <div class=\"modal-body\">\n" +
    "    <p>{{theInfo.statement||theInfo.$statement}}</p>\n" +
    "    <ul class=\"list-unstyled\">\n" +
    "      <li ng-repeat=\"resource in (theInfo.$resources||theInfo.resources)\" ng-bind-html=\"resource | niacsResourceDisplay\"></li>\n" +
    "      <li ng-if=\"(theInfo.external_link && theInfo.external_link.length) || (theInfo.$external_link && theInfo.$external_link.length)\" ng-repeat=\"external in (theInfo.external_link||theInfo.$external_link)\"><a target=\"external_evidence\" href=\"{{external.url}}\"><fa-icon icon=\"link\"></fa-icon> {{external.title}}</a></li>\n" +
    "      <li ng-if=\"theInfo.$local_link && theInfo.$local_link.length\" ng-repeat=\"local in theInfo.$local_link\"><a target=\"local_evidence\" href=\"{{local.self}}\"><fa-icon icon=\"file-pdf\"></fa-icon> {{local.filename}}</a></li>\n" +
    "    </ul>\n" +
    "  </div>");
}]);

angular.module("partials/dialogs/print.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("partials/dialogs/print.html",
    "<div class=\"modal-header\">\n" +
    "    <p><fa-icon icon=\"print\"></fa-icon> This Climate Adaptation Plan has been formatted for printing in landscape mode.</p>\n" +
    "</div>\n" +
    "<div class=\"modal-footer\">\n" +
    "    <button class=\"btn btn-default niacs-btn-action\" ng-click=\"$uibModalInstance.close()\">OK</button>\n" +
    "</div>\n" +
    "");
}]);

angular.module("partials/dialogs/resources.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("partials/dialogs/resources.html",
    "<div class=\"modal-header\">\n" +
    "    <font-awesome-action action=\"dismiss()\" icon=\"times-circle\" add-classes=\"niacs-right\" size=\"1_5\"></font-awesome-action>\n" +
    "    <h5>{{title}}</h5>\n" +
    "  </div>\n" +
    "  <div class=\"modal-body\">\n" +
    "    <div class=\"panel panel-default\" ng-repeat=\"resource in resources\">\n" +
    "      <div class=\"panel-heading\">{{resource.label}}</div>\n" +
    "      <div class=\"panel-body\">\n" +
    "        <p>{{resource.description}}</p>\n" +
    "        <p ng-if=\"resource.author.length\" ng-bind-html=\"resource | niacsResourceDisplay:true:true\"></p>\n" +
    "        <ul class=\"list-group\">\n" +
    "          <li class=\"list-group-item\" ng-repeat=\"attachment in resource.attachment\"><a href=\"{{attachment.self}}\" target=\"_blank\"><fa-icon icon=\"{{niacs.getFileTypeIcon(attachment.filemime)}}\" class=\"fa-1_5x\"></fa-icon> {{attachment.description||attachment.filename}}</a></li>\n" +
    "          <li class=\"list-group-item\" ng-repeat=\"link in resource.link\"><a href=\"{{link.url}}\" target=\"_blank\"><fa-icon icon=\"link\" class=\"fa-1_5x\"></fa-icon> {{link.title}}</a></li>\n" +
    "        </ul>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>");
}]);

angular.module("partials/dialogs/safe-confirm-dialog.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("partials/dialogs/safe-confirm-dialog.html",
    "<div class=\"modal-header\">\n" +
    "    <span ng-if=\"!contents.noIcon\"><fa-icon icon=\"{{contents.icon||'exclamation-triangle'}}\" class=\"fa-{{contents.iconSize||'3'}}x\"></fa-icon></span>\n" +
    "    <h4>{{contents.message}}</h4>\n" +
    "  </div>\n" +
    "  <div class=\"modal-body\">\n" +
    "    <p ng-if=\"contents.warning\" class=\"text-danger\">Warning: {{contents.warning}}</p>\n" +
    "    <p ng-if=\"contents.more\">{{contents.more}}</p>\n" +
    "    <p ng-if=\"contents.conditions.length\" class=\"text-warning\">Please check the following boxes to indicate you understand before confirming.</p>\n" +
    "    <ul class=\"list-unstyled\" ng-if=\"contents.conditions.length\">\n" +
    "        <li ng-repeat=\"condition in contents.conditions\"><input type=\"checkbox\" ng-model=\"contents.conditionsMet[$index]\" /> {{condition}}</li>\n" +
    "    </ul>\n" +
    "  </div>\n" +
    "  <div class=\"modal-footer\">\n" +
    "    <button class=\"btn btn-default\" ng-click=\"ok()\" ng-disabled=\"!allConditionsMet()\">{{contents.okText||'OK'}}</button>\n" +
    "    <button class=\"btn btn-default\" ng-click=\"cancel()\">{{contents.cancelText||'Cancel'}}</button>\n" +
    "  </div>");
}]);

angular.module("partials/dialogs/slow-down.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("partials/dialogs/slow-down.html",
    "<div class=\"modal-header\">\n" +
    "    <img ng-src=\"{{ModuleUrl}}/app_src/js/partials/dialogs/turtle_icon.png\" alt=\"Slow Down to Consider...\" title=\"Slow Down to Consider...\" />\n" +
    "    <div>Slow Down to Consider...</div>\n" +
    "</div>\n" +
    "<div class=\"modal-body\">\n" +
    "    <div class=\"slow-down-content\">\n" +
    "        <custom-html key=\"{{textKey}}\"></custom-html>\n" +
    "    </div>\n" +
    "<input type=\"checkbox\" ng-model=\"project.meta.noNag[text.label]\" id=\"noNag\"> <label for=\"noNag\">Don't show this again.</label>\n" +
    "<button class=\"btn btn-default niacs-btn-action btn-block\" ng-click=\"dismiss()\">Continue working on this step</button>\n" +
    "<button class=\"btn btn-default niacs-btn-action btn-block\" ng-click=\"close()\">Move on!</button>\n" +
    "</div>\n" +
    "");
}]);

angular.module("partials/dialogs/welcome.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("partials/dialogs/welcome.html",
    "<div class=\"modal-header\">\n" +
    "    <h1>Welcome to the Adaptation Workbook</h1>\n" +
    "</div>\n" +
    "<div class=\"modal-body\">\n" +
    "    <div class=\"welcome-content\">\n" +
    "        <custom-html key=\"{{textKey}}\"></custom-html>\n" +
    "    </div>\n" +
    "<input type=\"checkbox\" ng-model=\"project.meta.noNag[text.label]\"> Don't show this again.\n" +
    "<button class=\"btn btn-default niacs-btn-action btn-block\" ng-click=\"close()\">Get Started</button>\n" +
    "</div>\n" +
    "");
}]);

angular.module("partials/directives/climate-impact-statement-info.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("partials/directives/climate-impact-statement-info.html",
    "<label>{{statement.label||statement.$label}}</label>\n" +
    "<ul class=\"{{listStyle}}\" ng-if=\"!noEvidence && (statement.$evidence || statement.$agreement)\">\n" +
    "    <li>Evidence: {{statement.$evidence}}</li>\n" +
    "    <li>Agreement: {{statement.$agreement}}</li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("partials/directives/climate-impacts.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("partials/directives/climate-impacts.html",
    "<niacs-title-panel type=\"l2\"\n" +
    "    ng-if=\"potentials.length\"\n" +
    "    unique-id=\"usedImpacts.{{unit.id||project.id}}\"\n" +
    "    panel-title=\"Potential Climate Impacts - {{(unit||project) | unitLabel:project:true}}\">\n" +
    "    <div ng-repeat=\"statement in statements | preFromUser | inflate:potentials\" class=\"well\">\n" +
    "        <ul class=\"list-inline niacs-right\">\n" +
    "          <li><font-awesome-action icon=\"times-circle\" action=\"removeCallback(statement,unit||project);\" icon-tooltip=\"Remove\"></font-awesome-action></li>\n" +
    "        </ul>\n" +
    "        <div class=\"iblock-wrapper\">\n" +
    "          <a href ng-if=\"hasEvidence(statement)\" class=\"more-info cis-evidence\" uib-tooltip=\"Click to see evidence\" tooltip-placement=\"auto left\" ng-click=\"showEvidence(statement)\"></a>\n" +
    "          <em ng-if=\"!hasEvidence(statement)\" class=\"cis-evidence\">No evidence provided</em>\n" +
    "          <niacs-cis-info statement=\"statement\" list-style=\"list-inline pipe\" no-evidence></niacs-cis-info>\n" +
    "        </div>\n" +
    "\n" +
    "        <br />How might this affect your property or project area?&nbsp;<font-awesome-action ng-if=\"!statement.comments && statement.comments !== ''\" size=\"1\" icon=\"comment\" icon-tooltip=\"Add Comments\" action=\"startComments(statement)\"></font-awesome-action>\n" +
    "        <div ng-if=\"statement.comments || statement.comments === ''\">\n" +
    "        <textarea custom-placeholder=\"IMPACT_MEANING_PLACEHOLDER\"\n" +
    "                  class=\"msd-elastic\" ng-class=\"{empty: !statement.comments}\"\n" +
    "                  ng-model=\"statement.comments\"\n" +
    "                  ng-keyup=\"statement.$keyup($event)\"\n" +
    "                  id=\"impact_meaning_{{statement.id}}\"\n" +
    "                  ng-focus=\"statement.$focus('comments',$event)\"\n" +
    "                  ng-blur=\"statement.$autosave()\"></textarea>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</niacs-title-panel>\n" +
    "\n" +
    "<niacs-title-panel type=\"l2\" unique-id=\"unusedImpacts.{{unit.id||project.id}}\" panel-title=\"Additional Potential Climate Impacts to add to my list\" ng-if=\"displayPredefined() && (potentials | inUse:statements).length\">\n" +
    "  <div class=\"well\" ng-repeat=\"statement in potentials | inUse:statements\">\n" +
    "    <ul class=\"list-inline niacs-right\">\n" +
    "      <li><font-awesome-action icon=\"plus-circle\" icon-tooltip=\"Add\" action=\"addCallback(statement,unit||project);\"></font-awesome-action></li>\n" +
    "    </ul>\n" +
    "    <div class=\"iblock-wrapper\">\n" +
    "      <a href ng-if=\"hasEvidence(statement)\" class=\"more-info cis-evidence\" uib-tooltip=\"Click to see evidence\" tooltip-placement=\"auto left\" ng-click=\"showEvidence(statement)\"></a>\n" +
    "      <em ng-if=\"!hasEvidence(statement)\" class=\"cis-evidence\">No evidence provided</em>\n" +
    "      {{statement.label}}\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</niacs-title-panel>\n" +
    "\n" +
    "<niacs-title-panel type=\"l2\" unique-id=\"{{unitType()}}_customImpacts.{{unit.id||project.id}}\"\n" +
    "                   panel-title=\"Custom Climate Impacts - {{unit?(unit.label||unit.$label):'Regional'}}\">\n" +
    "  <div ng-repeat=\"statement in statements | preFromUser:'user'\" class=\"well\">\n" +
    "    <ul class=\"list-inline niacs-right\">\n" +
    "      <li><font-awesome-action icon=\"pencil\" action=\"editCustom(statement)\" icon-tooltip=\"Edit\"></font-awesome-action></li>\n" +
    "      <li><font-awesome-action icon=\"times-circle\" action=\"removeCustom(statement,unit||project)\" icon-tooltip=\"Remove\"></font-awesome-action></li>\n" +
    "    </ul>\n" +
    "    <div class=\"iblock-wrapper\">\n" +
    "        <a href ng-if=\"hasEvidence(statement)\" class=\"more-info cis-evidence\" uib-tooltip=\"Click to see evidence\" tooltip-placement=\"auto left\" ng-click=\"showEvidence(statement)\"></a>\n" +
    "        <em ng-if=\"!hasEvidence(statement)\" class=\"cis-evidence\">No evidence provided</em>\n" +
    "        <label>{{statement.label}}</label>\n" +
    "      </div>\n" +
    "      <p>{{statement.statement}}</p>\n" +
    "    </div>\n" +
    "    <button class=\"btn btn-default niacs-btn-action niacs-right\" ng-click=\"addCustom(unit||project)\">{{unit?('Add a Climate Impact Statement for '+(unit.label||unit.$label)):'Add a Regional Climate Impact Statement'}} <fa-icon icon=\"plus-circle\"></fa-icon></button>\n" +
    "</niacs-title-panel>\n" +
    "");
}]);

angular.module("partials/directives/font-awesome-action.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("partials/directives/font-awesome-action.html",
    "<a class=\"font-awesome-action {{faClass?faClass:''}} {{addClasses}}\" href ng-click=\"action();\" uib-tooltip=\"{{iconTooltip}}\" tooltip-placement=\"auto {{iconTooltipPlacement?iconTooltipPlacement:'bottom'}}\"><span ng-show=\"titleLeft\">{{title}} </span><fa-icon icon=\"{{icon}}\"  fa-prefix=\"{{faPrefix}}\" class=\"fa-{{size?size:'1_5'}}x\"></fa-icon><span ng-show=\"!titleLeft\"> {{title}}</span></a>\n" +
    "");
}]);

angular.module("partials/directives/goal-objective-form.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("partials/directives/goal-objective-form.html",
    "<niacs-title-panel panel-title=\"Goal #{{index}}\"\n" +
    "                   type=\"l2\"\n" +
    "                   add-classes=\"goal\"\n" +
    "                   unique-id=\"unit.{{context.id}}.goal.{{goal.id||'new'}}\">\n" +
    "<form class=\"form-horizontal\" name=\"modGoalForm{{$index}}\" role=\"form\">\n" +
    "    <div class=\"container-fluid\">\n" +
    "        <div class=\"row\">\n" +
    "        <div class=\"col-xs-10 static-goal-description\" ng-if=\"$goal.$description\">\n" +
    "          <p>{{$goal.$description}}</p>\n" +
    "        </div>\n" +
    "        <div class=\"col-xs-10\" ng-if=\"!$goal.$description\">\n" +
    "          <textarea class=\"msd-elastic goal\" ng-class=\"{empty: !$goal.description}\" ng-model=\"$goal.description\"\n" +
    "            ng-keyup=\"$goal.$keyup($event)\"\n" +
    "            id=\"goal_tf_{{goal.id}}\"\n" +
    "            ng-focus=\"$goal.$focus('description',$event)\" ng-blur=\"$goal.$autosave()\"\n" +
    "            custom-placeholder=\"ADDGOAL_PLACEHOLDER\"></textarea>\n" +
    "        </div>\n" +
    "        <div class=\"col-xs-2\">\n" +
    "            <ul class=\"list-inline niacs-right\">\n" +
    "              <li ng-if=\"$goal.$description\"><font-awesome-action icon=\"pencil\"\n" +
    "                                   icon-tooltip=\"Edit goal\"\n" +
    "                                   action=\"visit('goals','goals.'+project.id,'unit.'+project.id+'.goal.'+$goal.id)\"></font-awesome-action></li>\n" +
    "              <li ng-if=\"goal.id\"><font-awesome-action\n" +
    "                                   icon=\"times-circle\" icon-tooltip=\"Remove Goal\"\n" +
    "                                   action=\"removeGoal();\"></font-awesome-action></li>\n" +
    "            </ul>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    </div>\n" +
    "    <div class=\"well\" ng-repeat=\"objective in objectives\">\n" +
    "      <font-awesome-action ng-hide=\"!goal.id || objective.$new\"\n" +
    "               icon=\"times-circle\" icon-tooltip=\"Remove Objective\"\n" +
    "               add-classes=\"niacs-right\"\n" +
    "               action=\"removeObjective(objective)\"></font-awesome-action>\n" +
    "      <label>Objective</label>\n" +
    "      <div class=\"container-fluid\">\n" +
    "        <div class=\"row\">\n" +
    "          <div class=\"col-xs-9 form-group\">\n" +
    "            <textarea class=\"msd-elastic\" ng-class=\"{empty: !objective.description}\" ng-model=\"objective.description\"\n" +
    "              ng-keyup=\"objective.$keyup($event)\"\n" +
    "              id=\"obj_tf_{{objective.id}}\"\n" +
    "              ng-focus=\"objective.$focus('description',$event)\" ng-blur=\"objective.$autosave()\"\n" +
    "              custom-placeholder=\"ADDOBJECTIVE_PLACEHOLDER\"></textarea>\n" +
    "          </div>\n" +
    "          <div class=\"col-xs-3\">\n" +
    "            <div style=\"float: right;\"><info-icon key=\"TOOLTIP_OBJECTIVE_TIMEFRAME\" icon-color=\"black\"></info-icon></div>\n" +
    "            <input type=\"text\" class=\"timeframe\" ng-model=\"objective.timeframe\" placeholder=\"Time Frame\"\n" +
    "                     ng-disabled=\"!objective.id\"\n" +
    "                     ng-keyup=\"objective.$keyup($event)\"\n" +
    "                     id=\"obj_tf_tf_{{objective.id}}\"\n" +
    "                     ng-focus=\"objective.$focus('timeframe',$event)\" ng-blur=\"objective.$autosave()\" />\n" +
    "          </div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <button ng-if=\"!$goal.objectives[$goal.objectives.length-1].$new || $goal.objectives.length == 0\"\n" +
    "            class=\"btn btn-default niacs-btn-action secondary niacs-right\" ng-click=\"addObjective()\">Add Objective for this Goal <fa-icon icon=\"plus-circle\"></fa-icon></button>\n" +
    "</form>\n" +
    "</niacs-title-panel>\n" +
    "");
}]);

angular.module("partials/directives/navigation.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("partials/directives/navigation.html",
    "<div class=\"niacs-navigation clearfix\">\n" +
    "    <!-- {{current.label}} -->\n" +
    "    <div ng-show=\"previous\" class=\"previous\">\n" +
    "        <a href ng-click=\"go(previous)\"><fa-icon icon=\"chevron-left\"></fa-icon> Previous</a>\n" +
    "        <p>{{previous.label}}</p>\n" +
    "    </div>\n" +
    "    <div ng-show=\"next\" class=\"next\">\n" +
    "        <a href ng-click=\"go(next)\">Next <fa-icon icon=\"chevron-right\"></fa-icon></a>\n" +
    "        <p>{{next.label}}</p>\n" +
    "    </div>\n" +
    "\n" +
    "</div>\n" +
    "");
}]);

angular.module("partials/directives/objective-evaluate.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("partials/directives/objective-evaluate.html",
    "<niacs-title-panel unique-id=\"eval.obj.{{objective.id}}\" type=\"l2\"\n" +
    "       add-classes=\"objective-evaluate\"\n" +
    "       ng-repeat=\"objective in $goal.objectives\"\n" +
    "       panel-title=\"Goal #{{$index+1}}: {{$goal.description||$goal.$description}}<p>Objective: {{objective.description}}</p>\"\n" +
    "       panel-banner-status=\"{{objective | objectiveEvaluateObjectCompleteness}}\"\n" +
    "       panel-banner=\"{{objective | objectiveEvaluateObjectCompleteness:true}}\">\n" +
    "  <form role=\"form\">\n" +
    "    <div class=\"form-group well\">\n" +
    "      <label>Challenges</label>\n" +
    "      <niacs-statement-form add-label=\"Add a Challenge\" objective=\"objective\" save-callback=\"saveStatementCallback\" remove-callback=\"removeStatementCallback\" type=\"challenge\"></niacs-statement-form>\n" +
    "    </div>\n" +
    "    <div class=\"form-group well\">\n" +
    "      <label>Opportunities</label>\n" +
    "      <niacs-statement-form add-label=\"Add an Opportunity\" objective=\"objective\" save-callback=\"saveStatementCallback\" remove-callback=\"removeStatementCallback\" type=\"opportunity\"></niacs-statement-form>\n" +
    "    </div>\n" +
    "    <div class=\"form-group well\">\n" +
    "      <label>Feasibility Under Current Management</label><info-panel key=\"TOOLTIP_OBJ_FEASIBILITY\" icon-color=\"black\"></info-panel>\n" +
    "      <div class=\"row\">\n" +
    "          <div class=\"col-xs-2\">\n" +
    "              <select name=\"feasibility\" class=\"form-control\" ng-options=\"o.id as o.label for o in vocab_feasibility\" ng-model=\"objective.evaluate.feasibility\" ng-change=\"objective.$autosave()\"></select>\n" +
    "          </div>\n" +
    "          <div class=\"col-xs-10\">\n" +
    "              <textarea custom-placeholder=\"OBJECTIVE_FEASIBILITY_PLACEHOLDER\"\n" +
    "                        class=\"msd-elastic\" ng-class=\"{empty: !objective.evaluate.feasibility_comments}\"\n" +
    "                        ng-model=\"objective.evaluate.feasibility_comments\"\n" +
    "                        ng-keyup=\"objective.$keyup($event)\"\n" +
    "                        id=\"obj_feasability_tf_{{objective.id}}\"\n" +
    "                        ng-focus=\"objective.$focus('evaluate.feasibility_comments',$event)\" ng-blur=\"objective.$autosave()\"></textarea>\n" +
    "          </div>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <div class=\"form-group well\">\n" +
    "      <label>Other Considerations</label>\n" +
    "      <textarea custom-placeholder=\"OBJECTIVE_CONSIDERATIONS_PLACEHOLDER\"\n" +
    "                class=\"msd-elastic\" ng-class=\"{empty: !objective.evaluate.considerations}\"\n" +
    "                ng-model=\"objective.evaluate.considerations\"\n" +
    "                ng-keyup=\"objective.$keyup($event)\"\n" +
    "                id=\"obj_considerations_tf_{{objective.id}}\"\n" +
    "                ng-focus=\"objective.$focus('evaluate.considerations',$event)\" ng-blur=\"objective.$autosave()\"></textarea>\n" +
    "    </div>\n" +
    "  </form>\n" +
    "</niacs-title-panel>\n" +
    "");
}]);

angular.module("partials/directives/project-debug.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("partials/directives/project-debug.html",
    "<niacs-title-panel type=\"l1\" add-classes=\"debug-panel\" panel-title=\"Project Data Debug {{project.label}}\" ng-show=\"$showDebug\">\n" +
    "    <ul class=\"list-inline\">\n" +
    "      <li><input type=\"checkbox\" ng-model=\"json.privateData\" /> Show Private Data</li>\n" +
    "      <li><input type=\"checkbox\" ng-model=\"json.prettyPrint\" /> Pretty Print</li>\n" +
    "      <li ng-show=\"json.privateData\"><input type=\"text\" placeholder=\"Fields\" ng-model=\"json.fields\" /></li>\n" +
    "      <li><a href ng-click=\"stringify()\"><fa-icon icon=\"sync-alt\"></fa-icon></a></li>\n" +
    "      <li>{{json.size}}{{json.sizeUnits}}</li>\n" +
    "      <li>&nbsp;</li>\n" +
    "      <li><input type=\"checkbox\" ng-model=\"debug.info\" /> Info Log</li>\n" +
    "      <li><input type=\"checkbox\" ng-model=\"debug.log\" /> Log Log</li>\n" +
    "      <li><input type=\"checkbox\" ng-model=\"debug.debug\" /> Debug Log</li>\n" +
    "    </ul>\n" +
    "    <pre>{{json.stringified}}</pre>\n" +
    "</niacs-title-panel>\n" +
    "");
}]);

angular.module("partials/directives/project-details.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("partials/directives/project-details.html",
    "<div class=\"niacs-right\" ng-if=\"resetNoNag\"><a href ng-click=\"resetNoNag()\">Reset Slowdown Dialogs</a></div>\n" +
    "<div class=\"niacs-project-overview\">\n" +
    "    <h5 class=\"summary\">{{project.label}}<span ng-if=\"project.acres\"> - {{project.acres | number}} acres</span><span ng-if=\"project.size\"> - {{project.size}} (size)</span><span ng-show=\"project.ownership\"> - {{project.ownership | niacsTerm:vocab_ownership}} ownership</span></h5>\n" +
    "    <p class=\"summary\" ng-show=\"project.description\">{{project.description}}</p>\n" +
    "    <dl class=\"dl-horizontal\">\n" +
    "      <dt>Latitude:</dt><dd>{{project.lat}}</dd>\n" +
    "      <dt>Longitude:</dt><dd>{{project.lon}}</dd>\n" +
    "      <dt>State:</dt><dd>{{project.state | niacsTerm:vocab_state}}</dd>\n" +
    "      <dt>NIACS Region:</dt><dd>{{project.$vuln_region.label}}</dd>\n" +
    "    </dl>\n" +
    "</div>\n" +
    "");
}]);

angular.module("partials/directives/pw-goals.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("partials/directives/pw-goals.html",
    "<niacs-title-panel panel-title=\"Goal #{{index}}\"\n" +
    "                   type=\"l2\"\n" +
    "                   add-classes=\"goal\"\n" +
    "                   unique-id=\"unit.{{context.id}}.goal.{{goal.id||'new'}}\">\n" +
    "<form class=\"form-horizontal\" name=\"modGoalForm{{$index}}\" role=\"form\">\n" +
    "    <div class=\"container-fluid\">\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"col-xs-11\">\n" +
    "              <textarea class=\"msd-elastic goal\" ng-class=\"{empty: !$goal.description}\" ng-model=\"$goal.description\"\n" +
    "                ng-keyup=\"$goal.$keyup($event)\"\n" +
    "                ng-focus=\"$goal.$focus('description')\" ng-blur=\"$goal.$autosave()\"\n" +
    "                custom-placeholder=\"ADDGOAL_PLACEHOLDER\"></textarea>\n" +
    "            </div>\n" +
    "            <div class=\"col-xs-1\">\n" +
    "              <font-awesome-action ng-hide=\"!goal.id\"\n" +
    "                         icon=\"times-circle\" icon-tooltip=\"Remove Goal\"\n" +
    "                         action=\"removeGoal();\"></font-awesome-action>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"col-xs-10\"><label><custom-text key=\"LABEL_GOAL_APPLY\"></custom-text></label><info-panel key=\"TOOLTIP_GOAL_APPLY\" icon-color=\"black\"></info-panel></div>\n" +
    "            <div class=\"col-xs-2\">\n" +
    "            <toggle on=\"{{!goal.$unitVisibility}}\"\n" +
    "                    classes=\"pull-right\"\n" +
    "                    on-toggle=\"goal.$unitVisibility=!goal.$unitVisibility\"\n" +
    "                    on-tooltip=\"Show All Management Topics\"\n" +
    "                    off-tooltip=\"Show Only Applicable Management Topics\"></toggle>\n" +
    "        </div>\n" +
    "        </div>\n" +
    "      </div>\n" +
    "      <div class=\"well well-sm goal-applicable-unit-well\"\n" +
    "           ng-repeat=\"unit in context.units | inflate:context.$vuln_region.$units\"\n" +
    "           ng-if=\"$goal.$new||goal.$unitVisibility||unit.$applicableGoal[goal.id]\">\n" +
    "          <div class=\"row\">\n" +
    "            <div class=\"col-xs-2 unit-applicable-controls\">\n" +
    "              <div class=\"is-appplicable btn-group\">\n" +
    "                  <label class=\"no btn btn-default btn-xs\" ng-model=\"unit.$applicableGoal[goal.id]\" uib-btn-radio=\"false\" ng-change=\"changeApplicability(unit)\"></label>\n" +
    "                  <label class=\"yes btn btn-default btn-xs\" ng-model=\"unit.$applicableGoal[goal.id]\" uib-btn-radio=\"true\" ng-change=\"changeApplicability(unit)\"></label>\n" +
    "              </div>\n" +
    "            </div>\n" +
    "            <div class=\"col-xs-10\">\n" +
    "              <label>{{unit.label||unit.$label}}</label>\n" +
    "              <a href class=\"more-info\"\n" +
    "                  uib-popover-template=\"'partials/popovers/unit-info.html'\"\n" +
    "                  popover-placement=\"auto bottom\"\n" +
    "                  popover-append-to-body=\"true\"\n" +
    "                  popover-trigger=\"'mouseenter'\"></a>\n" +
    "              <!--p>{{unit.description||unit.$description||'&nbsp;'}}</p-->\n" +
    "            </div>\n" +
    "          </div>\n" +
    "      </div>\n" +
    "</form>\n" +
    "</niacs-title-panel>\n" +
    "");
}]);

angular.module("partials/directives/recap-climate-impacts.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("partials/directives/recap-climate-impacts.html",
    "<niacs-title-panel ng-if=\"statements && statements.length > 0\" unique-id=\"cisRecap.{{context.id}}\" type=\"{{panelType||'recap'}}\" add-classes=\"climate_impacts\" panel-title=\"{{panelTitle||'Review Potential Climate Impacts'}}\"\n" +
    "    info-icon-key=\"{{infoIconKey}}\" dockable=\"{{dockable}}\"\n" +
    "    initial-state=\"{{initialState||'closed'}}\">\n" +
    "    <table class=\"table table-condensed table-striped\">\n" +
    "        <tbody>\n" +
    "            <tr ng-repeat=\"statement in statements\">\n" +
    "                <td ng-if=\"statement.label\"\n" +
    "                            popover-title=\"Custom Climate Impact Statement\"\n" +
    "                            uib-popover=\"{{statement.statement}}\"\n" +
    "                            popover-placement=\"auto bottom\"\n" +
    "                            popover-trigger=\"'mouseenter'\">{{statement.label}}</td>\n" +
    "                <td ng-if=\"!statement.label\"\n" +
    "                            popover-title=\"{{statement.$popoverTitle}}\"\n" +
    "                            uib-popover=\"{{statement.$statement}}\"\n" +
    "                            popover-placement=\"auto bottom\"\n" +
    "                            popover-trigger=\"'mouseenter'\">{{statement.$label}}</td>\n" +
    "            </tr>\n" +
    "        </tbody>\n" +
    "    </table>\n" +
    "</niacs-title-panel>\n" +
    "");
}]);

angular.module("partials/directives/root-dashboard.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("partials/directives/root-dashboard.html",
    "<div class=\"dashboard\" ng-cloak class=\"dashboardApp ng-cloak\" ng-controller=\"ProjectDashboardCtrl\">\n" +
    "    <div ng-controller=\"NotificationCtrl\">\n" +
    "      <div uib-alert ng-repeat=\"alert in alerts\" ng-class=\"'alert-'+alert.type\" close=\"closeAlert($index)\"><span ng-bind-html=\"alert.msg\"></span></div>\n" +
    "    </div>\n" +
    "\n" +
    "    <pane-set unique-id=\"dashboard\" open-heading-cols=\"4\">\n" +
    "        <pane-set-header ng-controller=\"MyAccountCtrl\">\n" +
    "            <h3>My Projects</h3>\n" +
    "            <a href class=\"pull-right my-profile\"\n" +
    "                uib-popover-template=\"'partials/user-profile.html'\"\n" +
    "                popover-placement=\"auto bottom\"\n" +
    "                popover-trigger=\"'outsideClick'\"><fa-icon icon=\"user\"></fa-icon> My Profile</a>\n" +
    "        </pane-set-header>\n" +
    "        <pane-set-footer>\n" +
    "            <button ng-if=\"enrolledCourses && !enrolledCourses.list.length\" class=\"btn btn-default niacs-btn-action pull-right ng-cloak hidden-xs\" ng-cloak ng-click=\"createProject()\">Add a Project <fa-icon icon=\"plus-circle\"></fa-icon></button>\n" +
    "            <div class=\"btn-group pull-right ng-cloak hidden-xs\" ng-cloak uib-dropdown ng-if=\"enrolledCourses  && enrolledCourses.list.length\">\n" +
    "                <button id=\"create-project\" type=\"button\" class=\"btn btn-default niacs-btn-action\" uib-dropdown-toggle>Add a Project <fa-icon icon=\"plus-circle\"></fa-icon></button>\n" +
    "                <ul class=\"dropdown-menu\" uib-dropdown-menu role=\"menu\" aria-labelledby=\"create-project\">\n" +
    "                    <li role=\"menuitem\" ng-repeat=\"course in enrolledCourses.list\">\n" +
    "                        <a href ng-click=\"createProject(course)\"\n" +
    "                            uib-popover=\"{{course.description}}\"\n" +
    "                            popover-placement=\"auto left\"\n" +
    "                            popover-trigger=\"'mouseenter'\">A project for &quot;{{course.title}}&quot;</a>\n" +
    "                    </li>\n" +
    "                    <li role=\"menuitem\"><a href ng-click=\"createProject()\">A standard project</a></li>\n" +
    "                </ul>\n" +
    "            </div>\n" +
    "            <p class=\"bg-danger text-info visible-xs-block\">The Adaptation Workbook full functionality is not designed for small screens.  Please visit the workbook with a larger device.</p>\n" +
    "        </pane-set-footer>\n" +
    "\n" +
    "        <pane ng-if=\"projects && !projects.length\" unique-id=\"no-projects\" heading-only>\n" +
    "            <pane-heading>\n" +
    "                <custom-html key=\"NEW_USER_NO_PROJECTS\" no-project></custom-html>\n" +
    "            </pane-heading>\n" +
    "        </pane>\n" +
    "\n" +
    "        <pane ng-repeat=\"project in projects\" unique-id=\"project.{{project.id}}\" pane-open=\"{{$first}}\">\n" +
    "            <pane-title title=\"{{project.label}}\"\n" +
    "                        banner=\"Created {{project.created | date:'longDate'}} | Last edited {{project.changed | date:'longDate'}}\"></pane-title>\n" +
    "\n" +
    "            <label class=\"general-header\">{{project.label}}</label>\n" +
    "            \n" +
    "            <div class=\"project-info-container\">\n" +
    "                <ul class=\"list-inline hidden-xs\">\n" +
    "                    <li><a href=\"niacs-project-ui#overview/{{project.id}}\" class=\"btn btn-default niacs-btn-action\">Open this project <fa-icon icon=\"arrow-circle-right\"></fa-icon></a></li>\n" +
    "                    <li><font-awesome-action title=\"Edit project details\" icon=\"pencil\" action=\"editProject(project)\"></font-awesome-action></li>\n" +
    "                    <li ng-if=\"project.training\"><font-awesome-action title=\"View course materials\" icon=\"list\" action=\"courseMaterials(project)\"></font-awesome-action></li>\n" +
    "                    <li><font-awesome-action title=\"Delete this project\" icon=\"times-circle\" action=\"deleteProject(project)\"></font-awesome-action></li>\n" +
    "                </ul>\n" +
    "                <a href=\"niacs-project-export#export/{{project.id}}\" class=\"btn btn-default niacs-btn-action visible-xs-inline-block\">View <fa-icon icon=\"arrow-circle-right\"></fa-icon></a>\n" +
    "                <p class=\"bg-danger text-info visible-xs-block\">The Adaptation Workbook full functionality is not designed for small screens.  Please visit the workbook with a larger device.</p>\n" +
    "                <ul class=\"list-inline\">\n" +
    "                    <li><label>Ownership:</label> {{project.ownership | niacsTerm:vocab_ownership}}</li>\n" +
    "                    <li ng-if=\"project.acres\"><label>Acres:</label> {{project.acres | number}}</li>\n" +
    "                    <li ng-if=\"project.size\"><label>Size:</label> {{project.size}}</li>\n" +
    "                </ul>\n" +
    "                <p>{{project.description}}</p>\n" +
    "            </div>\n" +
    "            <div class=\"project-map-container\"><project-map project=\"project\" add-classes=\"project-map\"></project-map></div>\n" +
    "        </pane>\n" +
    "    </pane-set>\n" +
    "</div>\n" +
    "");
}]);

angular.module("partials/directives/root-project.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("partials/directives/root-project.html",
    "<div>\n" +
    "    <workbook-menu-toggle></workbook-menu-toggle>\n" +
    "    <div class=\"workbook-menu navmenu navmenu-default navmenu-fixed-left offcanvas-sm ng-cloak\"  ng-controller=\"MenuCtrl\" ng-cloak>\n" +
    "        <a class=\"navmenu-brand\" href=\"/\">Adaptation Workbook</a>\n" +
    "        <ul class=\"nav navmenu-nav site-nav\">\n" +
    "            <li><a href=\"/niacs-project-dashboard\" class=\"dashboard\"><fa-icon icon=\"tachometer-alt\"></fa-icon> My dashboard</a></li>\n" +
    "            <li><a href=\"/user/logout\" class=\"logout\"><fa-icon icon=\"sign-out-alt\"></fa-icon> Log out</a></li>\n" +
    "            <niacs-resources-menu></niacs-resources-menu>\n" +
    "            <!--li><niacs-resources add-classes=\"region\"></niacs-resources></li-->\n" +
    "            <li class=\"nav-hr\" ng-if=\"project.label\">{{project.label}}</li>\n" +
    "        </ul>\n" +
    "        <ul class=\"nav navmenu-nav\">\n" +
    "            <li ng-repeat=\"item in menuItems\" ng-if=\"item.render != false\" class=\"{{item.item ? 'menu_'+item.item : ''}}\" ng-class=\"{active: item.active, 'nav-hr': (item.item == null), 'nav-nonstep': item.nonStep, 'nav-step': (!item.nonStep && item.item != null)}\">\n" +
    "                <span ng-if=\"item.item == null\">{{item.label}}</span>\n" +
    "                <a ng-if=\"item.item != null\" href\n" +
    "                    ng-click=\"go(item)\"><fa-icon\n" +
    "                        ng-if=\"item.item === 'overview' || item.item === 'export'\"\n" +
    "                        icon=\"{{item.item === 'overview' ? 'map' : 'share'}}\"></fa-icon> {{item.label}} <fa-icon class=\"active\" ng-if=\"item.active\" icon=\"chevron-right\"></fa-icon></a>\n" +
    "            </li>\n" +
    "        </ul>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"instructions-backdrop\">\n" +
    "        <div class=\"instructions-banner collapsed\"></div>\n" +
    "        <div class=\"training-materials collapsed\"></div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"niacs-project-container\" ng-cloak class=\"ng-cloak\">\n" +
    "        <div ng-controller=\"NotificationCtrl\" ng-cloak>\n" +
    "            <div uib-alert ng-repeat=\"alert in alerts\" ng-class=\"'alert-'+alert.type\" close=\"closeAlert($index)\"><span ng-bind-html=\"alert.msg\"></span></div>\n" +
    "        </div>\n" +
    "        <div ng-view></div>\n" +
    "    </div>\n" +
    "\n" +
    "    <project-debug></project-debug>\n" +
    "</div>");
}]);

angular.module("partials/directives/root-strategies.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("partials/directives/root-strategies.html",
    "<div class=\"ng-cloak anchor\" style=\"margin: 30px;\" id=\"strategiesList\" ng-controller=\"StrategiesPdfCtrl\" ng-cloak>\n" +
    "    <a class=\"hidden-anchor\" name=\"the-top\"> </a>\n" +
    "    <!-- table of contents -->\n" +
    "    <div id=\"toc\">\n" +
    "        <div class=\"logo\">\n" +
    "            <a href ng-click=\"print()\" class=\"print\" title=\"print\" tooltip=\"Print...\" tooltip-placement=\"left\"><fa-icon icon=\"print\"></fa-icon></a>\n" +
    "            <img src=\"/modules/custom/niacs_project_ui/img/niacs-logo-dark.png\" />\n" +
    "        </div>\n" +
    "        <h3>Adaptation Strategies and Approaches ({{strategySource.getSourceTitle()}})</h3>\n" +
    "        <h5><a target=\"_blank\" href=\"http://forestadaptation.org/framework-components/forest-adaptation-resources\">Adapted from Forest Adaptation Resources: Climate Change Tools and Approaches for Land Managers</a></h5>\n" +
    "        <h5><a target=\"_blank\" href=\"/\">Created using the NIACS Adaptation Workbook</a></h5>\n" +
    "        <ul>\n" +
    "            <li ng-repeat=\"strategy in strategies\">\n" +
    "                <a href=\"#strategy-{{strategy.id}}\">Strategy {{$index+1}}: {{strategy.name}}</a>\n" +
    "                <ul>\n" +
    "                    <li ng-repeat=\"approach in strategy.approaches\"><a href=\"#approach-{{approach.id}}\">{{approach.name}}</a></li>\n" +
    "                </ul>\n" +
    "            </li>\n" +
    "        </ul>\n" +
    "    </div>\n" +
    "\n" +
    "    <!-- details -->\n" +
    "    <div ng-repeat=\"strategy in strategies\" class=\"anchor\">\n" +
    "        <a class=\"hidden-anchor\" name=\"strategy-{{strategy.id}}\"> </a>\n" +
    "        <hr ng-if=\"!$first\" />\n" +
    "        <a href=\"#the-top\" class=\"to-top\" tooltip=\"Back to top\" tooltip-placement=\"left\"><fa-icon icon=\"arrow-up\"></fa-icon></a>\n" +
    "        <h3>Strategy {{$index+1}}: {{strategy.name}}</h3>\n" +
    "        <span ng-if=\"strategy.descriptionHtml\" ng-bind-html=\"strategy.descriptionHtml\"></span>\n" +
    "\n" +
    "        <div ng-repeat=\"approach in strategy.approaches\" class=\"approach anchor\">\n" +
    "            <a class=\"hidden-anchor\" name=\"approach-{{approach.id}}\" > </a>\n" +
    "            <a href=\"#the-top\" class=\"to-top\" tooltip=\"Back to top\" tooltip-placement=\"left\"><fa-icon icon=\"arrow-up\"></fa-icon></a>\n" +
    "            <h4>{{approach.name}}</h4>\n" +
    "            <span ng-if=\"approach.descriptionHtml\" ng-bind-html=\"approach.descriptionHtml\"></span>\n" +
    "            <div ng-if=\"approach.$exampleSets.length\">\n" +
    "                <h5>Examples</h5>\n" +
    "                <div ng-repeat=\"set in approach.$exampleSets\">\n" +
    "                    <h6 ng-if=\"set.heading\">{{set.heading}}</h6>\n" +
    "                    <ul>\n" +
    "                        <li ng-repeat=\"example in set.list\"><p>{{example}}</p></li>\n" +
    "                    </ul>\n" +
    "                </div>\n" +
    "\n" +
    "            </div>\n" +
    "        </div>\n" +
    "\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("partials/directives/show-hide.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("partials/directives/show-hide.html",
    "<font-awesome-action add-classes=\"niacs-right\"\n" +
    "                     icon=\"{{$context.show?'compress-alt':'expand-alt'}}\"\n" +
    "                     icon-tooltip=\"{{$context.show?'Collapse':'Expand'}}\"\n" +
    "                     action=\"$context.show=!$context.show\"></font-awesome-action>");
}]);

angular.module("partials/directives/statement-form.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("partials/directives/statement-form.html",
    "<div class=\"row\" ng-repeat=\"statement in statements\">\n" +
    "    <div class=\"col-xs-11\">\n" +
    "      <textarea class=\"msd-elastic stacked\" ng-class=\"{empty: !statement.description}\"\n" +
    "                ng-model=\"statement.description\"\n" +
    "                ng-keyup-off=\"statement.$keyup($event)\"\n" +
    "                id=\"statement_tf_{{statement.id}}\"\n" +
    "                ng-focus=\"statement.$focus('description',$event)\" ng-blur=\"statement.$autosave()\"\n" +
    "                custom-placeholder=\"{{placeHolderKey}}\"></textarea>\n" +
    "    </div>\n" +
    "    <div class=\"col-xs-1\">\n" +
    "      <font-awesome-action ng-show=\"statement.id\" action=\"removeCallback(objective,statement,type)\"\n" +
    "                           add-classes=\"right-aligned-x\"\n" +
    "                           icon=\"times-circle\" icon-tooltip=\"Remove\"></font-awesome-action>\n" +
    "    </div>\n" +
    "</div>\n" +
    "<div class=\"row\">\n" +
    "  <div class=\"col-xs-12\">\n" +
    "  <button class=\"btn btn-default niacs-btn-action secondary niacs-right\" ng-click=\"addPlaceholder()\">{{addLabel}} <fa-icon icon=\"plus-circle\"></fa-icon></button>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("partials/directives/tactic-details.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("partials/directives/tactic-details.html",
    "<div class=\"tactic-details\">\n" +
    "  <div class=\"row\" ng-if=\"full\">\n" +
    "    <div class=\"col-xs-12 details\">\n" +
    "      <div class=\"form-group\">\n" +
    "        <label>Tactical Details</label>\n" +
    "        <p>{{tactic.tactical|mightBeEmpty}}</p>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <div class=\"row\" ng-if=\"full\" ng-repeat=\"approach in tactic.approaches\">\n" +
    "    <div class=\"col-xs-12 strategy-approach\">\n" +
    "      <label>Strategy:</label> {{strategyName(approach.strategy)}}\n" +
    "      &gt; <label>Approach:</label> {{approachName(approach.strategy,approach.approach)}}\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <div class=\"row\">\n" +
    "    <div class=\"col-xs-9 benefits\">\n" +
    "      <div class=\"form-group\">\n" +
    "        <label>Benefits</label>\n" +
    "        <p>{{tactic.benefits|mightBeEmpty}}</p>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <div class=\"col-xs-3 timeframe\">\n" +
    "      <div class=\"form-group\">\n" +
    "        <label>Timeframe</label>\n" +
    "        <p>{{tactic.timeframe|mightBeEmpty}}</p>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "  <div class=\"row\">\n" +
    "    <div class=\"col-xs-9 drawbacks\">\n" +
    "      <div class=\"form-group\">\n" +
    "        <label>Drawbacks and Barriers</label>\n" +
    "        <p>{{tactic.drawbacks|mightBeEmpty}}</p>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "    <div class=\"col-xs-3 practicability\">\n" +
    "      <div class=\"form-group\">\n" +
    "        <label for=\"practicability\">Practicability</label>\n" +
    "        <p ng-bind-html=\"tactic.practicability|tacticPracticability:vocab_tactic_practicability\"></p>\n" +
    "      </div>\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>");
}]);

angular.module("partials/directives/title-panel.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("partials/directives/title-panel.html",
    "<div id=\"{{id}}\" class=\"panel panel-default niacs-{{cssType}}-panel {{addClasses}}\"\n" +
    "                 ng-class=\"{docked: showHide.docked, dockable: isDockable}\">\n" +
    "    <div class=\"panel-heading clearfix {{bold?'bold':''}} {{addHeadingClasses}}\">\n" +
    "        <niacs-show-hide ng-hide=\"noShowHide || showHide.docked\" context=\"showHide\"></niacs-show-hide>\n" +
    "        <!--font-awesome-action ng-if=\"isDockable\"\n" +
    "                             icon=\"caret-square-o-left\" action=\"showHide.docked=!showHide.docked\"\n" +
    "                             add-classes=\"dockable-control {{showHide.docked ? 'fa-rotate-180' : ''}}\"></font-awesome-action-->\n" +
    "        <button ng-if=\"xtraButton\" class=\"btn btn-default btn-xs niacs-right\" style=\"margin-right: 5px;\" ng-click=\"doAction(xtraButtonAction)\">{{xtraButton}}</button>\n" +
    "        <font-awesome-action ng-if=\"icon\" icon=\"{{icon}}\" action=\"doAction(iconAction)\" size=\"{{iconSize}}\" title=\"{{iconTitle}}\" icon-tooltip=\"{{iconTooltip}}\" add-classes=\"{{iconAddClasses}}\"></font-awesome-action>\n" +
    "        <span ng-if=\"icons\">\n" +
    "            <ul class=\"list-inline niacs-right\" style=\"margin-bottom: 0px;\">\n" +
    "                <li ng-repeat=\"i in icons\" ng-hide=\"i.hide\">\n" +
    "                    <font-awesome-action icon=\"{{i.icon}}\" action=\"doAction(i.action)\" size=\"{{i.size}}\" title=\"{{i.title}}\" icon-tooltip=\"{{i.tooltip}}\" add-classes=\"{{i.classes}}\">\n" +
    "                    </font-awesome-action>\n" +
    "                </li>\n" +
    "            </ul>\n" +
    "        </span>\n" +
    "        <div style=\"{{haveInfoText ? 'display: inline-block;' : ''}}\" class=\"title-holder\"><span ng-if=\"haveInfoText && !showHide.docked\" class=\"niacs-right\">&nbsp;&nbsp;<info-icon ng-if=\"!infoPanel\" key=\"{{infoIconKey}}\"></info-icon><info-panel ng-if=\"infoPanel\" key=\"{{infoIconKey}}\"></info-panel></span><span class=\"title-prefix\" ng-if=\"$titlePrefix\" ng-bind-html=\"$titlePrefix\"></span><span class=\"title\" ng-bind-html=\"$title\"></span></div>\n" +
    "        <div ng-if=\"$banner\" class=\"row banner {{panelBannerClasses}}\"><fa-icon ng-if=\"panelBannerStatus\" icon=\"exclamation-triangle\" class=\"banner-status {{panelBannerStatus}}\"></fa-icon><span ng-bind-html=\"$banner\"></span></div>\n" +
    "    </div>\n" +
    "    <div class=\"panel-body {{addBodyClasses}}\" ng-if=\"showHide.show\">\n" +
    "        <div ng-transclude></div>\n" +
    "        <button ng-if=\"!!nextAccordion\" class=\"btn btn-default niacs-btn-action secondary btn-next-accordion\" ng-click=\"nextAccordion(uniqueId)\">Next <fa-icon icon=\"arrow-circle-down\"></fa-icon></button>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("partials/directives/unit-comments.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("partials/directives/unit-comments.html",
    "<textarea custom-placeholder=\"UNIT_COMMENTS_PLACEHOLDER\"\n" +
    "          class=\"msd-elastic\" ng-class=\"{empty: !unit.comments}\"\n" +
    "          ng-model=\"unit.comments\"\n" +
    "          ng-keyup=\"unit.$keyup($event)\"\n" +
    "          id=\"unit_comments_{{unit.id}}\"\n" +
    "          ng-focus=\"unit.$focus('comments',$event)\"\n" +
    "          ng-blur=\"unit.$autosave()\"></textarea>\n" +
    "");
}]);

angular.module("partials/directives/vulnerability-info.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("partials/directives/vulnerability-info.html",
    "<ul class=\"{{listStyle}}\">\n" +
    "    <li><label>Vulnerability Determination:</label> <span ng-bind-html=\"target.vulnerability | vulnerabilityDetermination:vocab_vulnerability\"></span></li>\n" +
    "    <li><label>Potential Impacts:</label> {{target.potential_impacts | potentialImpacts}}</li>\n" +
    "    <li><label>Adaptive Capacity:</label> {{target.adaptive_capacity | adaptiveCapacity}}</li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("partials/directives/vulnerability-plot.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("partials/directives/vulnerability-plot.html",
    "<div class=\"vulnerability-plot-wrapper\">\n" +
    "    <div class=\"vulnerability-plot\" id=\"vulnerability_plot_{{target.id}}\"></div>\n" +
    "    <canvas class=\"vulnerability-plot-bg\" id=\"vulnerability_plot_bg_{{target.id}}\"></canvas>\n" +
    "</div>\n" +
    "");
}]);

angular.module("partials/directives/vulnerability-sliders-ag.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("partials/directives/vulnerability-sliders-ag.html",
    "<div class=\"vulnerability-sliders\">\n" +
    "    <div class=\"vulnerability-sliders-cover\" ng-if=\"vulnerabilityNotDeterminded\">\n" +
    "      <button class=\"btn btn-default niacs-btn-action\" ng-click=\"initVulnerability();\">Determine Vulnerability</button>\n" +
    "    </div>\n" +
    "\n" +
    "    <h3>Adjust sliders to represent your property or project area  <info-panel key=\"INFO_VULN_SLIDERS\" icon-color=\"black\"></info-panel></h3>\n" +
    "\n" +
    "    <div class=\"raw-vulnerability-slider\" ng-if=\"sliderOptions\">\n" +
    "        <input ng-model=\"target.$vulnerability\"\n" +
    "               type=\"text\" id=\"vulnerability-determination-{{target.id}}\"\n" +
    "               slider options=\"sliderOptions\"\n" +
    "               ng-disabled=\"!slidersEnabled\" />\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("partials/directives/vulnerability-sliders.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("partials/directives/vulnerability-sliders.html",
    "<div class=\"vulnerability-sliders\">\n" +
    "    <div class=\"vulnerability-sliders-cover\" ng-if=\"vulnerabilityNotDeterminded\">\n" +
    "      <button class=\"btn btn-default niacs-btn-action\" ng-click=\"initVulnerability();\">Determine Vulnerability</button>\n" +
    "    </div>\n" +
    "\n" +
    "    <h3>Adjust sliders to represent your property or project area  <info-panel key=\"INFO_VULN_SLIDERS\" icon-color=\"black\"></info-panel></h3>\n" +
    "    <p>Default values represent regional vulnerability determinations.</p>\n" +
    "\n" +
    "    <div class=\"container-fluid\">\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"col-xs-4\">\n" +
    "                <h3>Potential Impacts <info-panel key=\"INFO_VULN_POTENTIAL_IMPACTS\" icon-color=\"black\" placement=\"left\"></info-panel></h3>\n" +
    "            </div>\n" +
    "            <div class=\"col-xs-8\">\n" +
    "                <p><custom-text key=\"IMPACTS_INSTRUCTIONS\"></custom-text></p>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"potential-impacts-slider\">\n" +
    "        <input ng-model=\"target.$potential_impacts\"\n" +
    "               type=\"text\" id=\"potential-impacts-{{target.id}}\"\n" +
    "               slider options=\"piOptions\"\n" +
    "               ng-disabled=\"!slidersEnabled\" />\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"container-fluid\">\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"col-xs-4\">\n" +
    "                <h3>Adaptive Capacity <info-panel key=\"INFO_VULN_ADAPTIVE_CAPACITY\" icon-color=\"black\" placement=\"left\"></info-panel></h3>\n" +
    "            </div>\n" +
    "            <div class=\"col-xs-8\">\n" +
    "                <p>How resilient to climate change impacts or disturbance is this ecosystem/management topic on your property or project area?</p>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"adaptive-capacity-slider\">\n" +
    "        <input ng-model=\"target.$adaptive_capacity\"\n" +
    "               type=\"text\" id=\"adaptive-capacity-{{target.id}}\"\n" +
    "               slider options=\"acOptions\"\n" +
    "               ng-disabled=\"!slidersEnabled\" />\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("partials/evaluate.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("partials/evaluate.html",
    "<div ng-controller=\"EvaluateCtrl\">\n" +
    "    <pane-set unique-id=\"evaluate\" open-heading-cols=\"4\">\n" +
    "        <pane-set-header>\n" +
    "            <div class=\"pane-set-title\" title=\"Evaluate Objectives\"  info-key=\"TOOLTIP_EVAL_OBJECTIVES\" info-type=\"panel\"></div>\n" +
    "        </pane-set-header>\n" +
    "        <pane-set-footer>\n" +
    "            <niacs-navigation></niacs-navigation>\n" +
    "        </pane-set-footer>\n" +
    "\n" +
    "        <pane ng-if=\"project.$noObjectives\" unique-id=\"no-contexts-evaluate\" heading-only>\n" +
    "            <pane-heading>\n" +
    "                Please define <a href=\"#goals/{{project.id}}\">Management goals and objectives</a>.\n" +
    "            </pane-heading>\n" +
    "        </pane>\n" +
    "\n" +
    "        <pane ng-repeat=\"context in contexts\" unique-id=\"eval.objectives.{{context.id}}\" pane-open=\"{{$first}}\">\n" +
    "            <pane-title title=\"{{context.$s3_unitLabel}} Objectives\"\n" +
    "                        banner=\"{{context.$s3_banner}}\"\n" +
    "                        status=\"{{context.$s3_status}}\"></pane-title>\n" +
    "            <niacs-recap-climate-impacts context=\"project\"\n" +
    "                statements=\"project.$cistatements_inflated\"\n" +
    "                panel-title=\"Review Potential Regional Climate Impacts\"\n" +
    "                info-icon-key=\"TOOLTIP_RECAP_REGIONAL_CLIMATE_IMPACTS\"></niacs-recap-climate-impacts>\n" +
    "            <niacs-recap-climate-impacts context=\"context\"\n" +
    "                panel-title=\"Review Potential {{context.$s3_unitLabel}} Climate Impacts\"\n" +
    "                statements=\"context.$cistatements_inflated\"></niacs-recap-climate-impacts>\n" +
    "            <div ng-repeat=\"goal in context.$goals_inflated\">\n" +
    "                <niacs-objective-evaluate context=\"context\"\n" +
    "                                          goal=\"goal\"\n" +
    "                                          save-objective-callback=\"saveObjective\"\n" +
    "                                          save-statement-callback=\"saveStatement\"\n" +
    "                                          remove-statement-callback=\"removeStatement\"></niacs-objective-evaluate>\n" +
    "            </div>\n" +
    "        </pane>\n" +
    "    </pane-set>\n" +
    "</div>\n" +
    "");
}]);

angular.module("partials/export.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("partials/export.html",
    "<div ng-controller=\"ExportCtrl\">\n" +
    "    <static-pane-set open-heading-cols=\"12\">\n" +
    "        <pane-set-header>\n" +
    "            <div class=\"pane-set-title\" title=\"Export and Share Plan\"></div>\n" +
    "        </pane-set-header>\n" +
    "        <pane-set-footer>\n" +
    "            <niacs-navigation></niacs-navigation>\n" +
    "        </pane-set-footer>\n" +
    "        <pane-set-left>\n" +
    "\n" +
    "                <niacs-title-panel id=\"exportControl\" unique-id=\"download.share\" type=\"l2\" panel-title=\"Download and share your workbook\">\n" +
    "                    <ul class=\"list-inline\">\n" +
    "                        <li><a class=\"btn btn-default big-secondary\" href ng-click=\"print()\"><fa-icon icon=\"print\"></fa-icon> Print Current Version</a></li>\n" +
    "                        <li><a class=\"btn btn-default big-secondary\" href ng-click=\"saveAsHtml()\"><fa-icon icon=\"code\"></fa-icon> Save as HTML</a><a id=\"htmlSaver\" style=\"display:none;\">-</a></li>\n" +
    "                        <li><a class=\"btn btn-default big-secondary\" target=\"mail\" href=\"mailto:dshannon@mtu.edu\"><fa-icon icon=\"envelope\"></fa-icon> Contact Us</a></li>\n" +
    "                        <li ng-if=\"!findDemoProjects\"><a class=\"btn btn-default big-secondary\" target=\"adaptation_browse\" href=\"https://forestadaptation.org/adapt/demonstration-projects\"><fa-icon icon=\"binoculars\"></fa-icon> Browse Other Adaptation Projects</a></li>\n" +
    "                        <li ng-if=\"findDemoProjects\"><a class=\"btn btn-default big-secondary\" href ng-click=\"findDemoProjects()\"><fa-icon icon=\"binoculars\"></fa-icon> Browse Other Adaptation Projects</a></li>\n" +
    "                    </ul>\n" +
    "                </niacs-title-panel>\n" +
    "\n" +
    "                <div class=\"well\" ng-if=\"niacs.collectObjectives(project,true) == 0\">Please define <a href=\"#goals/{{project.id}}\">Management goals and objectives</a>.</div>\n" +
    "\n" +
    "                <div id=\"theDocument\">\n" +
    "\n" +
    "                    <section id=\"CoverPage\" class=\"cover-page page-break after\">\n" +
    "                        <h1>Climate Change Adaptation Plan</h1>\n" +
    "                        <h2>{{project.label}}</h2>\n" +
    "                        <h4>{{today | date:'longDate'}}</h4>\n" +
    "                        <h4>Prepared by {{userProfile.full_name||'?'}}</h4>\n" +
    "                        <h3>Prepared using the Adaptation Workbook - AdaptationWorkbook.org</h3>\n" +
    "                        <div class=\"cover-details\">\n" +
    "                            <div class=\"property-map-image replace-with-image\" image-ready=\"{{mapStatus.ready}}\">\n" +
    "                                <div class=\"project-map-container\"><project-map project=\"project\" add-classes=\"project-map\" on-ready=\"mapStatus.ready = true;\"></project-map></div>\n" +
    "                            </div>\n" +
    "                            <div class=\"property-details\">\n" +
    "                                <h4>Property details</h4>\n" +
    "                                <ul class=\"list-unstyled\">\n" +
    "                                    <li ng-if=\"project.acres\"><label>Acres</label> {{project.acres | number}}</li>\n" +
    "                                    <li ng-if=\"project.size\"><label>Size</label> {{project.size}}</li>\n" +
    "                                    <li ng-if=\"project.ownership\"><label>Ownership</label> {{project.ownership | niacsTerm:vocab_ownership}}</li>\n" +
    "                                    <li ng-if=\"project.description\"><p>{{project.description}}</p></li>\n" +
    "                                </ul>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </section>\n" +
    "\n" +
    "                    <section id=\"table-of-contents\" class=\"page-break after print-only\">\n" +
    "                        <h1>Table of Contents</h1>\n" +
    "                        <ol>\n" +
    "                            <li><a href=\"#ProjectGoalsObjectives\">Project Goals and Objectives</a>\n" +
    "                                <ol type=\"a\">\n" +
    "                                    <li ng-repeat=\"unit in units | inflate:project.$vuln_region.$units\">\n" +
    "                                        <a href=\"#GoalsAndObjectives_{{unit.id}}\">{{unit | unitLabel:project}}</a>\n" +
    "                                    </li>\n" +
    "                                </ol>\n" +
    "                            </li>\n" +
    "                            <li><a href=\"#ClimateImactsVulnerabilities\">Climate Change Impacts and Vulnerabilities</a>\n" +
    "                                <ol type=\"a\">\n" +
    "                                    <li ng-repeat=\"unit in projectAndUnits | inflate:project.$vuln_region.$units\">\n" +
    "                                        <a ng-if=\"$index === 0\" href=\"#ClimateImactsVulnerabilities_Regional\">Regional Climate Impacts and Vulnerabilities</a>\n" +
    "                                        <a ng-if=\"$index > 0\" href=\"#ClimateImactsVulnerabilities_{{unit.id}}\">{{unit | unitLabel:project}}</a>\n" +
    "                                    </li>\n" +
    "                                </ol>\n" +
    "                            </li>\n" +
    "                            <li><a href=\"#EvaluateManagementObjectives\">Evaluation of Management Objectives</a>\n" +
    "                                <ol type=\"a\">\n" +
    "                                    <li ng-repeat=\"unit in units | inflate:project.$vuln_region.$units\">\n" +
    "                                        <a href=\"#EvaluateManagementObjectives_{{unit.id}}\">{{unit | unitLabel:project}}</a>\n" +
    "                                    </li>\n" +
    "                                </ol>\n" +
    "                            </li>\n" +
    "                            <li><a href=\"#AdaptationTactics\">Adaptation Tactics</a>\n" +
    "                                <ol type=\"a\">\n" +
    "                                    <li ng-repeat=\"unit in units | inflate:project.$vuln_region.$units\"><a href=\"#AdaptationTactics_{{unit.id}}\">{{unit | unitLabel:project}}</a></li>\n" +
    "                                </ol>\n" +
    "                            </li>\n" +
    "                            <li><a href=\"#MonitoringPlan\">Monitoring Plan</a>\n" +
    "                                <ol type=\"a\">\n" +
    "                                    <li ng-repeat=\"unit in units | inflate:project.$vuln_region.$units\"><a href=\"#MonitoringPlan_{{unit.id}}\">{{unit | unitLabel:project}}</a></li>\n" +
    "                                </ol>\n" +
    "                            </li>\n" +
    "                            <li><a href=\"#References\">References</a></li>\n" +
    "                        </ol>\n" +
    "                    </section>\n" +
    "\n" +
    "                    <section id=\"ProjectGoalsObjectives\" class=\"page-break before\">\n" +
    "                        <h1>1. Project Goals and Objectives</h1>\n" +
    "                        <p>Management goals and objectives capture fundamental information about the project area or property and provide a starting point for considering climate change.</p>\n" +
    "                        <section ng-repeat=\"unit in units | inflate:project.$vuln_region.$units\" id=\"GoalsAndObjectives_{{unit.id}}\">\n" +
    "                            <h1>1{{a_z[$index]}}. {{unit | unitLabel:project}}: Goals and Objectives</h1>\n" +
    "                            <table class=\"table table-bordered two-columns with-preamble\">\n" +
    "                                <thead>\n" +
    "                                    <tr class=\"preamble\">\n" +
    "                                        <td colspan=\"2\">\n" +
    "                                            <p ng-if=\"unit.description || unit.$description\">{{unit.description || unit.$description}}</p>\n" +
    "                                            <p ng-if=\"unit.comments\">{{unit.comments}}</p>\n" +
    "                                        </td>\n" +
    "                                    </tr>\n" +
    "                                    <tr>\n" +
    "                                        <th>Goal</th>\n" +
    "                                        <th>Objectives and Timeframes</th>\n" +
    "                                    </tr>\n" +
    "                                </thead>\n" +
    "                                <tbody>\n" +
    "                                    <tr ng-repeat=\"goal in unit.goals | inflate:project.goals:true\">\n" +
    "                                        <td>{{goal.description||goal.$description}}</td>\n" +
    "                                        <td>\n" +
    "                                            <ul>\n" +
    "                                                <li ng-repeat=\"objective in goal.objectives\">{{objective.description}} <em ng-if=\"objective.timeframe\">({{objective.timeframe}})</em></li>\n" +
    "                                            </ul>\n" +
    "                                        </td>\n" +
    "                                    </tr>\n" +
    "                                </tbody>\n" +
    "                            </table>\n" +
    "                        </section>\n" +
    "                    </section>\n" +
    "\n" +
    "                    <section id=\"ClimateImactsVulnerabilities\" class=\"page-break before\">\n" +
    "                        <h1>2. Climate Change Impacts and Vulnerabilities</h1>\n" +
    "                        <p>Climate change will not affect all places in the same way. This section describes the anticipated effects of climate change within a region, and then provides additional details  how specific places within the project area may be affected. </p>\n" +
    "                        <section ng-repeat=\"unit in projectAndUnits | inflate:project.$vuln_region.$units\" id=\"ClimateImactsVulnerabilities_{{$index === 0 ? 'Regional' : unit.id}}\">\n" +
    "                            <h1 ng-if=\"$index === 0\">2{{a_z[$index]}}. Regional Climate Impacts and Vulnerabilities</h1>\n" +
    "                            <h1 ng-if=\"$index > 0\">2{{a_z[$index]}}. {{unit | unitLabel:project}}: Climate Impacts and Vulnerabilities</h1>\n" +
    "                            <table class=\"table table-bordered two-columns {{$index > 0 ? 'with-preamble' : ''}}\">\n" +
    "                                <thead>\n" +
    "                                    <tr ng-if=\"$index > 0\" class=\"preamble\">\n" +
    "                                        <td colspan=\"2\">\n" +
    "                                            <ul class=\"list-inline\">\n" +
    "                                                    <li ng-if=\"!isAgriculture\">\n" +
    "                                                        <label>Potential Impacts</label>\n" +
    "                                                        {{unit.potential_impacts | potentialImpacts}}\n" +
    "                                                    </li>\n" +
    "                                                    <li ng-if=\"!isAgriculture\">\n" +
    "                                                        <label>Adaptive Capacity</label>\n" +
    "                                                        {{unit.adaptive_capacity | adaptiveCapacity}}\n" +
    "                                                    </li>\n" +
    "                                                    <li>\n" +
    "                                                        <label>Vulnerability</label>\n" +
    "                                                        <span ng-bind-html=\"unit.vulnerability | vulnerabilityDetermination:vocab_vulnerability\"></span>\n" +
    "                                                    </li>\n" +
    "                                                </ul>\n" +
    "                                        </td>\n" +
    "                                    </tr>\n" +
    "                                    <tr>\n" +
    "                                        <th>Potential Climate Impact - <span ng-if=\"$index === 0\">Regional</span><span ng-if=\"$index > 0\">{{unit | unitLabel:project}}</span></th>\n" +
    "                                        <th>Property or Project Area Considerations</th>\n" +
    "                                    </tr>\n" +
    "                                </thead>\n" +
    "                                <tbody>\n" +
    "                                    <tr ng-repeat=\"statement in unit.cistatements | inflate:($index === 0 ? unit.$vuln_region.$cistatements : unit.$cistatements)\">\n" +
    "                                        <td>{{statement.label||statement.$label}}\n" +
    "                                        <ul class=\"citations\" ng-if=\"statement.$resources.length\"><li ng-repeat=\"r in statement.$resources\"><a ng-href=\"#Reference_{{r.id}}\" class=\"html-export-only\">{{resourceCitations[r.id]}}</a><span class=\"export-view-only\">{{resourceCitations[r.id]}}</span></li></ul>\n" +
    "                                        </td>\n" +
    "                                        <td>{{climateImpactStatementComments(statement)}}</td>\n" +
    "                                    </tr>\n" +
    "                                </tbody>\n" +
    "                            </table>\n" +
    "                        </section>\n" +
    "                    </section>\n" +
    "\n" +
    "                    <section id=\"EvaluateManagementObjectives\" class=\"page-break before\">\n" +
    "                        <h1>3. Evaluation of Management Objectives</h1>\n" +
    "                        <p>Climate change might make management objectives for this property harder or easier to achieve, presenting challenges and opportunities. This section also includes a simple rating and description for the feasibility of meeting management objectives under current management. This is a critical step to evaluate whether management objectives are robust, or whether any might need to be changed.</p>\n" +
    "                        <section ng-repeat=\"unit in units | inflate:project.$vuln_region.$units\" id=\"EvaluateManagementObjectives_{{unit.id}}\">\n" +
    "                            <h1>3{{a_z[$index]}}. {{unit | unitLabel:project}}: Evaluation of Management Objectives</h1>\n" +
    "                            <table class=\"table table-bordered three-columns with-preamble\" ng-repeat=\"goal in unit.goals | inflate:project.goals:true\">\n" +
    "                                <thead>\n" +
    "                                    <tr class=\"preamble\">\n" +
    "                                        <td colspan=\"3\">\n" +
    "                                            <p><label>Management Goal</label> {{goal.description||goal.$description}}</p>\n" +
    "                                        </td>\n" +
    "                                    </tr>\n" +
    "                                    <tr>\n" +
    "                                        <th>Management Objective</th>\n" +
    "                                        <th>Challenges and Opportunities</th>\n" +
    "                                        <th>Feasibility</th>\n" +
    "                                    </tr>\n" +
    "                                </thead>\n" +
    "                                <tbody>\n" +
    "                                    <tr ng-repeat=\"objective in goal.objectives\">\n" +
    "                                        <td>{{objective.description}} <em ng-if=\"objective.timeframe\">({{objective.timeframe}})</em></td>\n" +
    "                                        <td>\n" +
    "                                            <label class=\"block\">Challenges</label>\n" +
    "                                            <span ng-if=\"!objective.evaluate.challenges || objective.evaluate.challenges.length === 0\">None identified</span>\n" +
    "                                            <ul ng-if=\"objective.evaluate.challenges && objective.evaluate.challenges.length > 0\">\n" +
    "                                                <li ng-repeat=\"challenge in objective.evaluate.challenges\">{{challenge.description}}</li>\n" +
    "                                            </ul>\n" +
    "                                            <label class=\"block\">Opportunities</label>\n" +
    "                                            <span ng-if=\"!objective.evaluate.opportunities || objective.evaluate.opportunities.length === 0\">None identified</span>\n" +
    "                                            <ul ng-if=\"objective.evaluate.opportunities && objective.evaluate.opportunities.length > 0\">\n" +
    "                                                <li ng-repeat=\"opportunity in objective.evaluate.opportunities\">{{opportunity.description}}</li>\n" +
    "                                            </ul>\n" +
    "                                        </td>\n" +
    "                                        <td>\n" +
    "                                            <label>Feasibility</label> {{objective.evaluate.feasibility | niacsTerm:vocab_feasibility:'Not specified'}}\n" +
    "                                            <label class=\"block\">Feasibility Comment</label>\n" +
    "                                            <p>{{objective.evaluate.feasibility_comments||'No comments'}}</p>\n" +
    "                                            <label class=\"block\">Other Considerations</label>\n" +
    "                                            <p>{{objective.evaluate.considerations||'No other considerations'}}</p>\n" +
    "                                        </td>\n" +
    "                                    </tr>\n" +
    "                                </tbody>\n" +
    "                            </table>\n" +
    "                        </section>\n" +
    "                    </section>\n" +
    "\n" +
    "                    <section id=\"AdaptationTactics\" class=\"page-break before\">\n" +
    "                        <h1>4. Adaptation Tactics</h1>\n" +
    "                        <p>After considering the challenges and opportunities climate change might present for this management objective, these actions were identified to help prepare for climate change impacts. Each adaptation tactic is linked to one or more Adaptation Strategies and Approaches, which provide connections to more general concepts related to forest management and conservation. Tactics that are recommended can be implemented or explored further.</p>\n" +
    "                        <section ng-repeat=\"unit in units | inflate:project.$vuln_region.$units\" ng-init=\"tacticData = tacticsData[unit.id]\" id=\"AdaptationTactics_{{unit.id}}\">\n" +
    "                            <h1>4{{a_z[$index]}}. {{unit | unitLabel:project}}: Adaptation Tactics</h1>\n" +
    "                            <table class=\"table table-bordered three-columns with-preamble\" ng-repeat=\"tactic in tacticData.tactics | inflate:project.tactics:true\">\n" +
    "                                <thead>\n" +
    "                                    <tr class=\"preamble\">\n" +
    "                                        <td colspan=\"3\">\n" +
    "                                            <p><label>Tactic</label> {{tactic.tactical}} <em ng-if=\"tactic.timeframe\">({{tactic.timeframe}})</em></p>\n" +
    "                                            <p><label>Practicability</label> <span ng-bind-html=\"tactic.$practicability|tacticPracticability:vocab_tactic_practicability\"></span></p>\n" +
    "                                        </td>\n" +
    "                                    </tr>\n" +
    "                                    <tr>\n" +
    "                                        <th>Adaptation Strategies and Approaches</th>\n" +
    "                                        <th>Benefits, Drawbacks and Barriers</th>\n" +
    "                                        <th>Associated Management Objectives</th>\n" +
    "                                    </tr>\n" +
    "                                </thead>\n" +
    "                                <tbody>\n" +
    "                                    <tr>\n" +
    "                                        <td>\n" +
    "                                            <div ng-repeat=\"group in tactic.$groupedApproaches\">\n" +
    "                                                <strong>{{strategyName(group.strategy)}}</strong>\n" +
    "                                                <ul>\n" +
    "                                                    <li ng-repeat=\"approach in group.approaches\">{{approachName(group.strategy,approach)}}</li>\n" +
    "                                                </ul>\n" +
    "                                            </div>\n" +
    "                                        </td>\n" +
    "                                        <td>\n" +
    "                                            <label class=\"block\">Benefits</label>\n" +
    "                                            <p>{{tactic.benefits||'Not specified'}}</p>\n" +
    "                                            <label class=\"block\">Drawbacks and Barriers</label>\n" +
    "                                            <p>{{tactic.drawbacks||'Not specified'}}</p>\n" +
    "                                        </td>\n" +
    "                                        <td>\n" +
    "                                            <ul>\n" +
    "                                                <li ng-repeat=\"objective in tacticData.toObjectives[tactic.id]\">\n" +
    "                                                    {{objective.description | exportEllipsis}} <em ng-if=\"objective.timeframe\">({{objective.timeframe}})</em>\n" +
    "                                                    <span ng-if=\"objective.$tacticsRecommendations[tactic.id] === false\"> <strong>Tactic not recommended for this objective</strong></span>\n" +
    "                                                </li>\n" +
    "                                            </ul>\n" +
    "                                        </td>\n" +
    "                                    </tr>\n" +
    "                                </tbody>\n" +
    "                            </table>\n" +
    "                        </section>\n" +
    "                    </section>\n" +
    "\n" +
    "                    <section id=\"MonitoringPlan\" class=\"page-break before\">\n" +
    "                        <h1>5. Monitoring Plan</h1>\n" +
    "                        <p>Monitoring is critical for understanding if management actions are e·ective or if management should be altered in the future to\n" +
    "                            account for new information. The following monitoring variables were described for this particular management objective and\n" +
    "                            adaptation tactics.</p>\n" +
    "                        <section ng-repeat=\"unit in units | inflate:project.$vuln_region.$units\" ng-init=\"monData = monitorData[unit.id]\" id=\"MonitoringPlan_{{unit.id}}\">\n" +
    "                            <h1>5{{a_z[$index]}}. {{unit | unitLabel:project}}: Monitoring Plan</h1>\n" +
    "                            <table class=\"table table-bordered three-columns with-preamble\" ng-repeat=\"monitor in monData.monitor | inflate:project.monitor:true\">\n" +
    "                                <thead>\n" +
    "                                    <tr class=\"preamble\">\n" +
    "                                        <td colspan=\"3\">\n" +
    "                                            <p><label>Monitoring Variable</label> {{monitor.vari}}</p>\n" +
    "                                        </td>\n" +
    "                                    </tr>\n" +
    "                                    <tr>\n" +
    "                                        <th>Criteria for Evaluation</th>\n" +
    "                                        <th>Plans for Implementation</th>\n" +
    "                                        <th>Associated Management Objectives</th>\n" +
    "                                    </tr>\n" +
    "                                </thead>\n" +
    "                                <tbody>\n" +
    "                                    <tr>\n" +
    "                                        <td>{{monitor.crit}}</td>\n" +
    "                                        <td>{{monitor.impl}}</td>\n" +
    "                                        <td>\n" +
    "                                            <ul>\n" +
    "                                                <li ng-repeat=\"objective in monData.toObjectives[monitor.id]\">\n" +
    "                                                    {{objective.description | exportEllipsis}} <em ng-if=\"objective.timeframe\">({{objective.timeframe}})</em>\n" +
    "                                                </li>\n" +
    "                                            </ul>\n" +
    "                                        </td>\n" +
    "                                    </tr>\n" +
    "                                </tbody>\n" +
    "                            </table>\n" +
    "                        </section>\n" +
    "                    </section>\n" +
    "\n" +
    "                    <section id=\"References\" class=\"page-break before\">\n" +
    "                        <h1>6. References</h1>\n" +
    "                        <p>\n" +
    "                            This adaptation plan was developed using the Adaptation Workbook (<a href=\"https://www.adaptationworkbook.org\" target=\"_blank\">www.adaptationworkbook.org</a>)\n" +
    "                            and Adaptation Strategies and Approaches developed by the Northern Institute of Applied Climate Science. View the Adaptation Strategies and Approaches at: \n" +
    "                            <a href=\"https://www.adaptationworkbook.org/strategies\" target=\"_blank\">www.adaptationworkbook.org/strategies</a>.\n" +
    "                        </p>\n" +
    "                        <div ng-if=\"resources.length > 0\">\n" +
    "                            <ol class=\"references\">\n" +
    "                                <li ng-repeat=\"resource in resources\" ng-bind-html=\"resource | niacsResourceReference\" id=\"Reference_{{resource.id}}\"></li>\n" +
    "                            </ol>\n" +
    "                        </div>\n" +
    "                    </section>\n" +
    "                </div>\n" +
    "        </pane-set-left>\n" +
    "    </static-pane-set>\n" +
    "</div>\n" +
    "");
}]);

angular.module("partials/goals.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("partials/goals.html",
    "<div ng-controller=\"UnitsCtrl\">\n" +
    "    <pane-set unique-id=\"goals\" open-heading-cols=\"4\">\n" +
    "        <pane-set-header>\n" +
    "            <div class=\"pane-set-title\" title=\"Management Goals and Objectives\"></div>\n" +
    "        </pane-set-header>\n" +
    "        <pane-set-footer>\n" +
    "            <niacs-navigation></niacs-navigation>\n" +
    "        </pane-set-footer>\n" +
    "\n" +
    "        <pane ng-repeat=\"context in contexts\" unique-id=\"goals.{{context.id}}\" pane-open=\"{{$first}}\">\n" +
    "            <pane-title title=\"{{context.id === project.id ? 'General Goals for the entire property or project area' : (context.$label||context.label)+' Goals and Objectives'}}\"\n" +
    "                        banner=\"{{context | goalObjectiveCount}}\"\n" +
    "                        status=\"{{project.id === context.id ? '' :((niacs.countObjectives(context)==0)? niacs.INCOMPLETE : niacs.COMPLETE)}}\"></pane-title>\n" +
    "            <info-panel key=\"TOOLTIP_{{project.id === context.id ? 'PW_' :''}}GOALS\" icon-color=\"not-white\"></info-panel>\n" +
    "            <div ng-repeat=\"goal in context.goals | inflate:project.goals:true\" ng-init=\"initNewGoalVisibility(context);\">\n" +
    "                <pw-goal ng-if=\"context.id === project.id\" context=\"context\" goal=\"goal\" index=\"{{$index+1}}\"></pw-goal>\n" +
    "                <niacs-goal-form ng-if=\"context.id !== project.id\" context=\"context\" goal=\"goal\" index=\"{{$index+1}}\"></niacs-goal-form>\n" +
    "            </div>\n" +
    "            <div class=\"action-trailer\">\n" +
    "                <button ng-click=\"addNewGoal(context);\" class=\"btn btn-default niacs-btn-action niacs-right\">Add Another Goal{{context.id === project.id ? '':'/Objective Set'}} <fa-icon icon=\"plus-circle\"></fa-icon></button>\n" +
    "            </div>\n" +
    "        </pane>\n" +
    "    </pane-set>\n" +
    "</div>\n" +
    "");
}]);

angular.module("partials/homework.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("partials/homework.html",
    "<div ng-controller=\"HomeworkCtrl\">\n" +
    "    <static-pane-set open-heading-cols=\"12\">\n" +
    "        <pane-set-header>\n" +
    "            <div class=\"pane-set-title\" title=\"{{homework.title}}\"></div>\n" +
    "        </pane-set-header>\n" +
    "        <pane-set-footer>\n" +
    "            <niacs-navigation></niacs-navigation>\n" +
    "        </pane-set-footer>\n" +
    "        <pane-set-left>\n" +
    "            <form name=\"homeowrkForm\">\n" +
    "                <div class=\"long-questions\" ng-if=\"homework.long.qs.length\">\n" +
    "                    <hw-text-answer homework-answers=\"project.training.homework[homework.id]\"\n" +
    "                                    answer-type=\"long\"\n" +
    "                                    question=\"q\"\n" +
    "                                    ng-repeat=\"q in homework.long.qs\"></hw-text-answer>\n" +
    "                </div>\n" +
    "\n" +
    "                <div class=\"qual-questions\" ng-if=\"homework.qual.qs.length\">\n" +
    "                    <hw-qual-answers homework-answers=\"project.training.homework[homework.id]\"\n" +
    "                                     homework-qual=\"homework.qual\"></hw-qual-answers>\n" +
    "                </div>\n" +
    "\n" +
    "                <div class=\"short-questions\" ng-if=\"homework.short.qs.length\">\n" +
    "                    <hw-text-answer homework-answers=\"project.training.homework[homework.id]\"\n" +
    "                            answer-type=\"short\"\n" +
    "                            question=\"q\"\n" +
    "                            ng-repeat=\"q in homework.short.qs\"></hw-text-answer>\n" +
    "                </div>\n" +
    "\n" +
    "            </form>\n" +
    "        </pane-set-left>\n" +
    "    </static-pane-set>\n" +
    "</div>\n" +
    "");
}]);

angular.module("partials/impacts.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("partials/impacts.html",
    "<div ng-controller=\"ImpactsCtrl\">\n" +
    "    <pane-set unique-id=\"impacts\" open-heading-cols=\"4\">\n" +
    "        <pane-set-header>\n" +
    "            <div class=\"pane-set-title\" title=\"Climate Impacts and Vulnerability\"></div>\n" +
    "        </pane-set-header>\n" +
    "        <pane-set-footer>\n" +
    "            <niacs-navigation></niacs-navigation>\n" +
    "        </pane-set-footer>\n" +
    "\n" +
    "        <pane ng-repeat=\"context in contexts\" unique-id=\"impacts.{{context.id}}\" pane-open=\"{{$first}}\">\n" +
    "            <pane-title title=\"Potential Climate Impacts - {{context | unitLabel:project:true}}\"\n" +
    "                        banner=\"Identified {{context.cistatements ? context.cistatements.length : 0}} Potential Climate Impacts\n" +
    "                        {{context.$unit_vulnerability ? '(Vulnerability: '+context.$unit_vulnerability+')' : ''}}\"\n" +
    "                        status=\"{{context.cistatements.length ? niacs.COMPLETE : niacs.INCOMPLETE}}\"></pane-title>\n" +
    "            <info-panel key=\"TOOLTIP_{{(context.id==project.id)?'PW':(niacs.isPredefined(context)?'PREDEF_UNIT_':'CUSTOM_UNIT_')}}CLIMATEIMPACTS\" icon-color=\"not-white\"></info-panel>\n" +
    "            <niacs-climate-impacts project=\"project\"\n" +
    "                                   unit=\"context.id == project.id ? null : context\"\n" +
    "                                   potentials=\"context.id == project.id ? project.$vuln_region.$cistatements : context.$cistatements\"\n" +
    "                                   add-callback=\"addCiStatement\"\n" +
    "                                   remove-callback=\"removeCiStatement\"\n" +
    "                                   save-callback=\"saveCiStatement\"></niacs-climate-impacts>\n" +
    "        </pane>\n" +
    "    </pane-set>\n" +
    "</div>\n" +
    "");
}]);

angular.module("partials/lms-export.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("partials/lms-export.html",
    "<div ng-controller=\"LmsProjectExport\">\n" +
    "    <div id=\"projectExport\" class=\"lms-project-view\" ng-if=\"project\">\n" +
    "        <lms-project-view project=\"project\"></lms-project-view>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("partials/lms/course-list.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("partials/lms/course-list.html",
    "<niacs-title-panel panel-title=\"NIACS Courses\" icons=\"panelIcons\" no-show-hide=\"true\">\n" +
    "    <course-listing ng-repeat=\"course in courses\" course=\"course\" post-update=\"reload()\"></course-listing>\n" +
    "    <p ng-if=\"!courses.length\">No Courses have been created yet.</p>\n" +
    "</niacs-title-panel>\n" +
    "\n" +
    "\n" +
    "\n" +
    "");
}]);

angular.module("partials/lms/course-listing.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("partials/lms/course-listing.html",
    "<niacs-title-panel panel-title=\"{{course.title}}\" type=\"l2\" unique-id=\"course.{{course.id}}\" accordion-member=\"true\"\n" +
    "    icons=\"panelIcons\" add-body-classes=\"course-listing\">\n" +
    "\n" +
    "    <p class=\"course-dates\">\n" +
    "        <label>Dates:</label>\n" +
    "        <span ng-if=\"course.startDate\">{{course.startDate | date:'shortDate'}} - {{course.endDate | date:'shortDate'}}</span>\n" +
    "        <span ng-if=\"!course.startDate\">Not Set</span>\n" +
    "    </p>\n" +
    "\n" +
    "    <p class=\"course-description\">{{course.description}}</p>\n" +
    "\n" +
    "    <niacs-title-panel panel-title=\"Materials\" type=\"l3\" unique-id=\"materials.{{course.id}}\" add-body-classes=\"course-listing-materials\">\n" +
    "        <table class=\"table table-striped table-condensed\">\n" +
    "            <tr ng-repeat=\"materials in course.materials\">\n" +
    "                <td>{{materials.title}}</td>\n" +
    "                <td class=\"text-right\">\n" +
    "                    <a target=\"_blank\" href=\"{{materials.edit}}\"\n" +
    "                       uib-tooltip=\"Edit {{materials.title}}\"\n" +
    "                       tooltip-placement=\"left\"><fa-icon icon=\"edit\"></fa-icon></a>\n" +
    "                </td>\n" +
    "            </tr>\n" +
    "        </table>\n" +
    "    </niacs-title-panel>\n" +
    "\n" +
    "    <niacs-title-panel panel-title=\"Homework\" type=\"l3\" unique-id=\"homework.{{course.id}}\" add-body-classes=\"course-listing-homework\">\n" +
    "        <table class=\"table table-striped table-condensed\" ng-repeat=\"(step,homeworks) in course.homework\">\n" +
    "            <thead>\n" +
    "                <tr>\n" +
    "                    <th>{{step}}</th>\n" +
    "                    <th>&nbsp;</th>\n" +
    "                    <th>&nbsp;</th>\n" +
    "                </tr>\n" +
    "            </thead>\n" +
    "            <tbody>\n" +
    "                <tr ng-repeat=\"homework in homeworks\">\n" +
    "                    <td>\n" +
    "                        <label>{{homework.title}}</label>\n" +
    "                    </td>\n" +
    "                    <td>\n" +
    "                        <homework-stats homework=\"homework\"></homework-stats>\n" +
    "                    </td>\n" +
    "                    <td class=\"text-right\">\n" +
    "                        <font-awesome-action icon=\"pencil\" icon-tooltip=\"Edit {{homework.title}}\" icon-tooltip-placement=\"left\" action=\"editHomework(homework)\"></font-awesome-action>\n" +
    "                    </td>\n" +
    "                </tr>\n" +
    "            </tbody>\n" +
    "        </table>\n" +
    "    </niacs-title-panel>\n" +
    "\n" +
    "    <niacs-title-panel panel-title=\"Enrollment\" type=\"l3\" unique-id=\"enrollment.{{course.id}}\" initial-state=\"closed\" add-body-classes=\"course-listing-enrollment\">\n" +
    "        <form class=\"form-inline\">\n" +
    "        <table class=\"table table-striped table-condensed\">\n" +
    "            <tr>\n" +
    "                <th>\n" +
    "                <div class=\"form-group\">\n" +
    "                <label for=\"studentToEnroll\">Enroll Student:</label>\n" +
    "                <input style=\"width: 300px\" id=\"studentToEnroll\" type=\"text\" ng-model=\"enrollment.studentToEnroll\" placeholder=\"e-mail\"\n" +
    "                     uib-typeahead=\"student as student.mail for student in getPotentialStudents($viewValue)\" class=\"form-control\" />\n" +
    "                </div>\n" +
    "                </th>\n" +
    "                <th class=\"text-right\">\n" +
    "                    <button class=\"btn btn-link\" ng-disabled=\"!haveStudentToEnroll() && !haveStudentToPreregister()\" ng-click=\"enrollStudent(enrollment.studentToEnroll)\" uib-tooltip=\"{{enrollment.studentToEnroll.uid ? 'Enroll' : 'Preregister'}} {{enrollment.studentToEnroll.mail}}\" tooltip-placement=\"left\" style=\"margin:0px; padding:0px\"><fa-icon icon=\"plus\" class=\"fa-1_5x\"></fa-icon></button>\n" +
    "                </th>\n" +
    "            </tr>\n" +
    "            <tr ng-repeat=\"student in course.enrollment\">\n" +
    "                <td>{{student | renderStudent}}</td>\n" +
    "                <td class=\"text-right\">\n" +
    "                    <font-awesome-action ng-if=\"projectAuthors.indexOf(student.mail) === -1\"\n" +
    "                            icon=\"times\" icon-tooltip=\"Disenroll {{student.mail}}\" icon-tooltip-placement=\"left\"\n" +
    "                            action=\"disenrollStudent(student);\"></font-awesome-action>\n" +
    "                </td>\n" +
    "            </tr>\n" +
    "            <tr ng-repeat=\"email in course.preregistration\">\n" +
    "                <td>{{email}} <strong><em>(preregistered)</em></strong></td>\n" +
    "                <td class=\"text-right\">\n" +
    "                    <font-awesome-action icon=\"times\"\n" +
    "                        icon-tooltip=\"Remove {{email}} from preregistration\" icon-tooltip-placement=\"left\"\n" +
    "                        action=\"removePreregistration(email)\"></font-awesome-action>\n" +
    "                </td>\n" +
    "            </tr>\n" +
    "        </table>\n" +
    "        </form>\n" +
    "    </niacs-title-panel>\n" +
    "\n" +
    "    <niacs-title-panel panel-title=\"Offerings\" type=\"l3\" unique-id=\"offerings.{{course.id}}\" add-body-classes=\"course-listing-offerings\" initial-state=\"closed\">\n" +
    "        <table class=\"table table-striped table-condensed\">\n" +
    "            <tr ng-repeat=\"offering in course.revisions\">\n" +
    "                <td>\n" +
    "                    {{offering.title}}\n" +
    "                    <span ng-if=\"course.version === offering.version\"> (Current)</span>\n" +
    "                </td>\n" +
    "                <td class=\"text-right\">\n" +
    "                    <ul class=\"list-inline\">\n" +
    "                        <li>\n" +
    "                            <font-awesome-action icon=\"list-ol\" icon-tooltip=\"Review Homework - {{offering.title}}\" icon-tooltip-placement=\"left\"\n" +
    "                                         action=\"reviewHomework(offering)\"></font-awesome-action>\n" +
    "                        </li>\n" +
    "                        <li>\n" +
    "                            <font-awesome-action icon=\"file-alt\" icon-tooltip=\"Review Projects - {{offering.title}}\" icon-tooltip-placement=\"left\"\n" +
    "                                         action=\"reviewProjects(offering)\"></font-awesome-action>\n" +
    "                        </li>\n" +
    "                    </ul>\n" +
    "                </td>\n" +
    "            </tr>\n" +
    "        </table>\n" +
    "    </niacs-title-panel>\n" +
    "\n" +
    "</niacs-title-panel>\n" +
    "");
}]);

angular.module("partials/lms/course-materials.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("partials/lms/course-materials.html",
    "<course-materials-route></course-materials-route>");
}]);

angular.module("partials/lms/edit-course-dialog.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("partials/lms/edit-course-dialog.html",
    "<div class=\"modal-header\">\n" +
    "    <font-awesome-action action=\"dismiss()\" icon=\"times-circle\" add-classes=\"niacs-right\" size=\"1_5\"></font-awesome-action>\n" +
    "    {{course.id ? 'Update' : 'Create'}} Course\n" +
    "  </div>\n" +
    "  <div class=\"modal-body clearfix\">\n" +
    "    <form name=\"newCourseForm\">\n" +
    "        <div class=\"form-group\">\n" +
    "            <label for=\"courseTitle\">Course title</label>\n" +
    "            <input type=\"text\" class=\"form-control\" id=\"courseTitle\" placeholder=\"Course title\" ng-model=\"course.title\" required>\n" +
    "        </div>\n" +
    "        <div class=\"row\">\n" +
    "          <div class=\"col-sm-12\">\n" +
    "            <p class=\"bg-info explanation\">The <em>From</em> and <em>To</em> dates are important because these dictate when enrolled users can create workbook projects\n" +
    "              associated with a given course.  Ininitially you may want to leave these blank when developing a course but you must set the dates\n" +
    "              the course is being offered in order to teach it.</p>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "        <div class=\"row\">\n" +
    "          <div class=\"col-sm-6 form-group\">\n" +
    "            <label for=\"courseDateFrom\">From</label>\n" +
    "            <input id=\"courseDateFrom\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"MM/dd/yyyy\" ng-model=\"course.startDate\" placeholder=\"mm/dd/yyyy\" is-open=\"course.$startOpen\" ng-focus=\"course.$startOpen = true;\"/>\n" +
    "          </div>\n" +
    "          <div class=\"col-sm-6 form-group\">\n" +
    "            <label for=\"courseDateTo\">To</label>\n" +
    "            <input id=\"courseDateTo\" type=\"text\" class=\"form-control\" uib-datepicker-popup=\"MM/dd/yyyy\" ng-model=\"course.endDate\" placeholder=\"mm/dd/yyyy\" is-open=\"course.$endOpen\" ng-focus=\"course.$endOpen = true;\"/>\n" +
    "          </div>\n" +
    "        </div>\n" +
    "        <div class=\"form-group\">\n" +
    "            <label for=\"courseTitle\">Course description</label>\n" +
    "            <textarea id=\"courseTitle\"\n" +
    "                  placeholder=\"Course description\"\n" +
    "                  class=\"msd-elastic\" ng-class=\"{empty: !course.description}\"\n" +
    "                  ng-model=\"course.description\" required></textarea>\n" +
    "        </div>\n" +
    "        <ul class=\"list-inline pull-right\">\n" +
    "            <li><a class=\"btn btn-default\" ng-click=\"dismiss()\">Cancel</a></li>\n" +
    "            <li><a class=\"btn btn-default\" ng-click=\"ok()\" ng-disabled=\"newCourseForm.$invalid\">{{course.id ? 'Update' : 'Create'}}</a></li>\n" +
    "        </ul>\n" +
    "    </form>\n" +
    "  </div>\n" +
    "");
}]);

angular.module("partials/lms/edit-homework-dialog.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("partials/lms/edit-homework-dialog.html",
    "<div class=\"modal-header\">\n" +
    "    <font-awesome-action action=\"dismiss()\" icon=\"times-circle\" add-classes=\"niacs-right\" size=\"1_5\"></font-awesome-action>\n" +
    "    Edit &quot;{{homework.title}}&quot;\n" +
    "  </div>\n" +
    "  <div class=\"modal-body clearfix\">\n" +
    "    <form name=\"editHomeworkForm\">\n" +
    "        <homework-questions question-set-title=\"Long Answer\" question-set=\"homework.long\"></homework-questions>\n" +
    "\n" +
    "        <homework-questions question-set-title=\"Qualitative Answer\" question-set=\"homework.qual\"></homework-questions>\n" +
    "\n" +
    "        <homework-questions question-set-title=\"Short Answer\" question-set=\"homework.short\"></homework-questions>\n" +
    "\n" +
    "        <ul class=\"list-inline pull-right\">\n" +
    "            <li><a class=\"btn btn-default\" ng-click=\"dismiss()\">Cancel</a></li>\n" +
    "            <li><a class=\"btn btn-default\" ng-click=\"ok()\" ng-disabled=\"editHomeworkForm.$invalid\">Update</a></li>\n" +
    "        </ul>\n" +
    "\n" +
    "        <!--br /><br /><pre>{{homework | json}}</pre-->\n" +
    "    </form>\n" +
    "  </div>");
}]);

angular.module("partials/lms/homework-export.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("partials/lms/homework-export.html",
    "<div class=\"homework-export\">\n" +
    "    <font-awesome-action action=\"export()\"\n" +
    "        icon=\"download\"\n" +
    "        icon-tooltip=\"Download as CSV\"\n" +
    "        icon-tooltip-placement=\"left\"\n" +
    "        size=\"1_5\"></font-awesome-action>\n" +
    "    <a id=\"homework-export-link\" style=\"display: none;\">export</a>\n" +
    "</div>");
}]);

angular.module("partials/lms/homework-questions.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("partials/lms/homework-questions.html",
    "<div class=\"homework-questions well\">\n" +
    "<font-awesome-action icon=\"plus\" icon-tooltip=\"Add Question\" add-classes=\"pull-right\" action=\"addQ()\"\n" +
    "      icon-tooltip=\"Add Question\"\n" +
    "      icon-tooltip-placement=\"left\"></font-awesome-action>\n" +
    "<h4>{{questionSetTitle}}</h4>\n" +
    "<div class=\"row\" ng-if=\"questionSet.from && questionSet.to && questionSet.qs.length\">\n" +
    "    <div class=\"col-xs-12 form-group\">\n" +
    "      <label for=\"qualTitle\">Qualitative Statement/Question</label>\n" +
    "      <input id=\"qualTitle\" class=\"form-control\" type=\"text\" ng-model=\"questionSet.title\" required />\n" +
    "    </div>\n" +
    "</div>\n" +
    "<div class=\"row\" ng-if=\"questionSet.from && questionSet.to && questionSet.qs.length\">\n" +
    "    <!-- from -->\n" +
    "    <div class=\"col-xs-3 form-group\">\n" +
    "      <label for=\"qualFromNum\">From</label>\n" +
    "      <input id=\"qualFromNum\" class=\"form-control\" type=\"number\" ng-model=\"questionSet.from.v\" required />\n" +
    "    </div>\n" +
    "    <div class=\"col-xs-3 form-group\">\n" +
    "      <label for=\"qualFromLabel\">From Label</label>\n" +
    "      <input id=\"qualFromLabel\" class=\"form-control\" type=\"text\" ng-model=\"questionSet.from.label\" required />\n" +
    "    </div>\n" +
    "    <!-- to -->\n" +
    "    <div class=\"col-xs-3 form-group\">\n" +
    "      <label for=\"qualToNum\">To</label>\n" +
    "      <input id=\"qualToNum\" class=\"form-control\" type=\"number\" ng-model=\"questionSet.to.v\" required />\n" +
    "    </div>\n" +
    "    <div class=\"col-xs-3 form-group\">\n" +
    "      <label for=\"qualToLabel\">To Label</label>\n" +
    "      <input id=\"qualToLabel\" class=\"form-control\" type=\"text\" ng-model=\"questionSet.to.label\" required />\n" +
    "    </div>\n" +
    "</div>\n" +
    "<div class=\"row question-list\" ng-repeat=\"q in questionSet.qs\">\n" +
    "    <div class=\"col-xs-11\">\n" +
    "        <input class=\"form-control\" type=\"text\" ng-model=\"q.q\" required />\n" +
    "    </div>\n" +
    "    <div class=\"col-xs-1\">\n" +
    "        <font-awesome-action icon=\"times\" icon-tooltip=\"Remove Question\" action=\"removeQ(q)\"\n" +
    "            icon-tooltip=\"Remove Question\"\n" +
    "            icon-tooltip-placement=\"left\"></font-awesome-action>\n" +
    "    </div>\n" +
    "</div>\n" +
    "</div>\n" +
    "\n" +
    "<!--pre>{{questionSet | json}}</pre-->");
}]);

angular.module("partials/lms/homework-review-qual.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("partials/lms/homework-review-qual.html",
    "<div ng-if=\"homeworkQual.qs.length\">\n" +
    "    <table class=\"table table-condensed table-striped qual-answers\">\n" +
    "        <thead>\n" +
    "            <tr>\n" +
    "                <th><label>{{homeworkQual.title}}</label></th>\n" +
    "                <th>&nbsp;</th>\n" +
    "                <th ng-repeat=\"i in qualRange\" class=\"rangeLabel text-center\">\n" +
    "                    <span ng-if=\"$first\">&nbsp({{homeworkQual.from.label}})<br /></span>\n" +
    "                    <span ng-if=\"$last\">&nbsp;({{homeworkQual.to.label}})<br /></span>\n" +
    "                    {{i}}\n" +
    "                </th>\n" +
    "                <th>&nbsp;</th>\n" +
    "            </tr>\n" +
    "        </thead>\n" +
    "        <tbody>\n" +
    "            <tr ng-repeat=\"q in homeworkQual.qs\">\n" +
    "                <td>{{q.q}}</td>\n" +
    "                <td class=\"no-padding qual-bordered\">\n" +
    "                    <ul class=\"list-unstyled qual-list\">\n" +
    "                        <li ng-repeat=\"project in projectList\"\n" +
    "                        ng-class=\"{even : $even, odd : $odd, first: $first, last: $last}\">&nbsp;&nbsp;{{project.author}}&nbsp;&nbsp;</li>\n" +
    "                    </ul>\n" +
    "                </td>\n" +
    "                <td ng-repeat=\"i in qualRange\" class=\"rangeValue no-padding qual-bordered\">\n" +
    "                    <ul class=\"list-unstyled qual-list\">\n" +
    "                        <li ng-repeat=\"yn in answerMap[q.id][i] track by $index\"\n" +
    "                            ng-class=\"{even : $even, odd : $odd, first: $first, last: $last, yes : yn}\">\n" +
    "                            &nbsp;\n" +
    "                        </li>\n" +
    "                    </ul>\n" +
    "                </td>\n" +
    "                <td class=\"text-center\" style=\"vertical-align: middle;\">\n" +
    "                    {{answerMap[q.id]['total']}}\n" +
    "                </td>\n" +
    "            </tr>\n" +
    "        </tbody>\n" +
    "    </table>\n" +
    "</div>");
}]);

angular.module("partials/lms/homework-review-text.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("partials/lms/homework-review-text.html",
    "<div ng-repeat=\"q in questions\">\n" +
    "    <label>{{q.q}}</label>\n" +
    "    <blockquote ng-repeat=\"answer in (answers[q.id] | orderBy:'author')\">\n" +
    "        <p>{{answer.answer}}</p>\n" +
    "        <footer>{{answer.author}}</footer>\n" +
    "    </blockquote>\n" +
    "</div>");
}]);

angular.module("partials/lms/homework-review.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("partials/lms/homework-review.html",
    "<div ng-repeat=\"(step,homeworks) in homework\">\n" +
    "    <niacs-title-panel type=\"l3\" ng-repeat=\"homework in homeworks\" panel-title=\"{{homework.title}}\" unique-id=\"hwrvw.{{homework.id}}\">\n" +
    "        <homework-text-review answers=\"answers\" questions=\"homework.long.qs\"></homework-text-review>\n" +
    "        <homework-qual-review answers=\"answers\" homework-qual=\"homework.qual\" projects=\"projects\"></homework-qual-review>\n" +
    "        <homework-text-review answers=\"answers\" questions=\"homework.short.qs\"></homework-text-review>\n" +
    "    </niacs-title-panel>\n" +
    "</div>\n" +
    "");
}]);

angular.module("partials/lms/homework-stats.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("partials/lms/homework-stats.html",
    "<div class=\"homework-stats\">\n" +
    "    <ul class=\"list-inline\" style=\"margin-bottom: 0px;\">\n" +
    "        <li>Long Answer: <span class=\"badge\" ng-class=\"{'has-hw': (homework.long.qs.length > 0)}\">{{homework.long.qs.length||0}}</span></li>\n" +
    "        <li>Qualitative Answer: <span class=\"badge\" ng-class=\"{'has-hw': (homework.qual.qs.length > 0)}\">{{homework.qual.qs.length||0}}</span></li>\n" +
    "        <li>Short Answer: <span class=\"badge\" ng-class=\"{'has-hw': (homework.short.qs.length > 0)}\">{{homework.short.qs.length||0}}</span></li>\n" +
    "    </ul>\n" +
    "</div>");
}]);

angular.module("partials/lms/hw-qual-answers.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("partials/lms/hw-qual-answers.html",
    "<label>{{homeworkQual.title}}</label>\n" +
    "<table class=\"table table-condensed table-striped\">\n" +
    "    <tr>\n" +
    "        <th>&nbsp;</th>\n" +
    "        <th ng-repeat=\"i in qualRange\" class=\"rangeLabel\">\n" +
    "            <span ng-if=\"$first\">{{homeworkQual.from.label}}</span>\n" +
    "            <span ng-if=\"$last\">{{homeworkQual.to.label}}</span>\n" +
    "        </th>\n" +
    "    </tr>\n" +
    "    <tr ng-repeat=\"q in homeworkQual.qs\">\n" +
    "        <td>{{q.q}}</td>\n" +
    "        <td ng-repeat=\"i in qualRange\" class=\"rangeValue\">\n" +
    "            <input type=\"radio\" ng-model=\"homeworkAnswers[q.id]\" value=\"{{i}}\" ng-change=\"onChange(q.id)\" ng-disabled=\"isSaving(q.id)\" />\n" +
    "        </td>\n" +
    "    </tr>\n" +
    "</table>");
}]);

angular.module("partials/lms/hw-text-answer.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("partials/lms/hw-text-answer.html",
    "<div class=\"form-group\">\n" +
    "    <label for=\"{{question.id}}\">{{question.q}}</label>\n" +
    "    <textarea ng-if=\"answerType === 'long'\"\n" +
    "            id=\"textAnswer{{question.id}}\"\n" +
    "            class=\"msd-elastic hwAnswer\" ng-class=\"{empty: !answer.text}\" ng-model=\"answer.text\"\n" +
    "            ng-keyup=\"answer.$keyup($event)\"\n" +
    "            ng-focus=\"answer.$focus('text',$event)\" ng-blur=\"answer.$autosave()\"\n" +
    "            placeholder=\"{{question.q}}\"></textarea>\n" +
    "    <input ng-if=\"answerType === 'short'\"\n" +
    "            id=\"textAnswer{{question.id}}\"\n" +
    "            type=\"text\" class=\"form-control hwAnswer\" ng-class=\"{empty: !answer.text}\" ng-model=\"answer.text\"\n" +
    "            ng-keyup=\"answer.$keyup($event)\"\n" +
    "            ng-focus=\"answer.$focus('text',$event)\" ng-blur=\"answer.$autosave()\"\n" +
    "            placeholder=\"{{question.q}}\" />\n" +
    "</div>\n" +
    "\n" +
    "");
}]);

angular.module("partials/lms/review-course-homework-dialog.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("partials/lms/review-course-homework-dialog.html",
    "<div class=\"modal-header clearfix\">\n" +
    "    <ul class=\"list-inline niacs-right\">\n" +
    "        <li ng-if=\"anySelected()\"><homework-export homework=\"offering.homework\" projects=\"toReview\" offering-title=\"{{offering.title}}\"></homework-export></li>\n" +
    "        <li><font-awesome-action action=\"dismiss()\" icon=\"times-circle\" size=\"1_5\"></font-awesome-action></li>\n" +
    "    </ul>\n" +
    "    Review Homework - {{offering.title}}\n" +
    "</div>\n" +
    "<div class=\"modal-body\">\n" +
    "    <table class=\"table table-hover table-condensed\">\n" +
    "        <thead>\n" +
    "            <tr>\n" +
    "                <th>Project</th>\n" +
    "                <th>Author</th>\n" +
    "                <th class=\"text-right\">\n" +
    "                    <font-awesome-action icon=\"{{allSelected() ? 'check-' : ''}}square\"\n" +
    "                                         action=\"toggleAll()\"></font-awesome-action>\n" +
    "                </th>\n" +
    "            </tr>\n" +
    "        </thead>\n" +
    "        <tbody>\n" +
    "            <tr ng-repeat=\"project in (projects.list | orderBy:'author')\">\n" +
    "                <td>{{project.label}}</td>\n" +
    "                <td>{{(enrollmentMap[project.author] | renderStudent)||project.author}}</td>\n" +
    "                <td class=\"text-right\">\n" +
    "                    <font-awesome-action icon=\"{{toReview[project.id] ? 'check-' : ''}}square\"\n" +
    "                                         action=\"toggleProject(project)\"></font-awesome-action>\n" +
    "                </td>\n" +
    "            </tr>\n" +
    "        </tbody>\n" +
    "    </table>\n" +
    "    <homework-review homework=\"offering.homework\" projects=\"toReview\" ng-if=\"anySelected()\"></homework-review>\n" +
    "</div>\n" +
    "");
}]);

angular.module("partials/lms/review-course-projects-dialog.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("partials/lms/review-course-projects-dialog.html",
    "<div class=\"modal-header\">\n" +
    "    <font-awesome-action action=\"dismiss()\" icon=\"times-circle\" add-classes=\"niacs-right\" size=\"1_5\"></font-awesome-action>\n" +
    "    Review Projects - {{offering.title}}\n" +
    "</div>\n" +
    "<div class=\"modal-body\">\n" +
    "    <table class=\"table table-hover table-condensed\">\n" +
    "        <thead>\n" +
    "            <tr>\n" +
    "                <th>Project</th>\n" +
    "                <th>Author</th>\n" +
    "                <th>&nbsp;</th>\n" +
    "            </tr>\n" +
    "        </thead>\n" +
    "        <tbody>\n" +
    "            <tr ng-repeat=\"project in (projects.list | orderBy:'author')\" ng-click=\"view(project)\" ng-class=\"{success: (viewProject.id === project.id)}\" style=\"cursor: pointer;\">\n" +
    "                <td>{{project.label}}</td>\n" +
    "                <td>{{(enrollmentMap[project.author] | renderStudent)||project.author}}</td>\n" +
    "                <td class=\"text-right\">\n" +
    "                    <a target=\"_blank\" ng-href=\"niacs-project-export#/lms-export/{{offering.id}}/{{offering.version}}/{{project.id}}\" alt=\"Printable version\" title=\"Printable version\"><fa-icon icon=\"external-link\"></fa-icon></a>\n" +
    "                </td>\n" +
    "            </tr>\n" +
    "        </tbody>\n" +
    "    </table>\n" +
    "    <div id=\"projectMap\" class=\"project-map-container\" ng-if=\"viewProject\" style=\"width: 500px; height: 300px; overflow: hidden;\">\n" +
    "        <project-map project=\"viewProject\" add-classes=\"project-map\" draggable=\"true\" zoom-control=\"true\"></project-map>\n" +
    "    </div>\n" +
    "    <div id=\"projectLocation\" ng-if=\"viewProject\"><label><a target=\"_blank\" ng-href=\"https://www.google.com/maps/@{{viewProject.lat}},{{viewProject.lon}},8z\">[{{viewProject.lat}},{{viewProject.lon}}]</a></label></div>\n" +
    "    <div id=\"projectExport\" class=\"lms-project-view\" ng-if=\"viewProject\">\n" +
    "        <font-awesome-action action=\"viewProject = null;\" icon=\"times-circle\" add-classes=\"niacs-right\" size=\"1_5\"></font-awesome-action>\n" +
    "        <lms-project-view project=\"viewProject\"></lms-project-view>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("partials/monitor.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("partials/monitor.html",
    "<div ng-controller=\"MonitorCtrl\">\n" +
    "    <static-pane-set open-heading-cols=\"12\">\n" +
    "        <pane-set-header>\n" +
    "            <div class=\"pane-set-title\" title=\"Monitoring Variables\"\n" +
    "                                        banner=\"{{project.monitor.length ? project.monitor.length : 0}} monitoring variables\"\n" +
    "                                        status=\"{{project | step5Completeness:true}}\"></div>\n" +
    "        </pane-set-header>\n" +
    "        <pane-set-footer>\n" +
    "            <niacs-navigation></niacs-navigation>\n" +
    "        </pane-set-footer>\n" +
    "        <pane-set-left>\n" +
    "            <div ng-if=\"objectiveCount == 0\">Please define <a href=\"#goals/{{project.id}}\">Management goals and objectives</a>.</div>\n" +
    "\n" +
    "            <niacs-title-panel ng-repeat=\"monitor in project.monitor\"\n" +
    "                               unique-id=\"monitor.{{monitor.id}}\"\n" +
    "                               type=\"l2\"\n" +
    "                               add-classes=\"monitor-panel\"\n" +
    "                               panel-title=\"Monitoring Variable: {{monitor.vari |mightBeEmpty:'&amp;lt;Empty&amp;gt;' |ellipses}}\"\n" +
    "                               panel-banner-status=\"{{monitor.$refCount ? niacs.COMPLETE : niacs.INCOMPLETE}}\"\n" +
    "                               panel-banner=\"Applicable to {{monitor.$refCount ? monitor.$refCount : 0}} objectives\"\n" +
    "                               icons=\"monitor.$controls\">\n" +
    "              <div class=\"container-fluid monitor-details\">\n" +
    "                <div class=\"row\">\n" +
    "                  <div class=\"col-xs-12\">\n" +
    "                    <div class=\"form-group\">\n" +
    "                      <label>Monitoring Variable</label>\n" +
    "                      <p>{{monitor.vari}}</p>\n" +
    "                    </div>\n" +
    "                  </div>\n" +
    "                  <div class=\"col-xs-12\">\n" +
    "                    <div class=\"form-group\">\n" +
    "                      <label>Criteria For Evaluation</label>\n" +
    "                      <p>{{monitor.crit |mightBeEmpty}}</p>\n" +
    "                    </div>\n" +
    "                  </div>\n" +
    "                  <div class=\"col-xs-12\">\n" +
    "                    <div class=\"form-group\">\n" +
    "                      <label>Monitoring Implementation</label>\n" +
    "                      <p>{{monitor.impl |mightBeEmpty}}</p>\n" +
    "                    </div>\n" +
    "                  </div>\n" +
    "                </div>\n" +
    "              </div>\n" +
    "\n" +
    "              <span ng-init=\"initMonitorRefVisibility(monitor)\">\n" +
    "                <div class=\"row\">\n" +
    "                  <div class=\"col-xs-6\"><label>Does this monitoring variable apply to these objectives?</label><info-panel key=\"TOOLTIP_APPLICABLE_MONITORING_PLAN\" icon-color=\"black\"></info-panel></div>\n" +
    "                  <div class=\"col-xs-6\">\n" +
    "                      <toggle on=\"{{monitorRefVisibility[monitor.id]}}\"\n" +
    "                              classes=\"pull-right\"\n" +
    "                              on-toggle=\"monitorRefVisibility[monitor.id]=!monitorRefVisibility[monitor.id]\"\n" +
    "                              on-tooltip=\"Show All Objectives\"\n" +
    "                              off-tooltip=\"Show Only Applicable Objectives\"></toggle>\n" +
    "                    <!--button class=\"btn btn-default niacs-btn-action niacs-right secondary\"\n" +
    "                            ng-class=\"{in: monitorRefVisibility[monitor.id]}\"\n" +
    "                            ng-click=\"monitorRefVisibility[monitor.id]=!monitorRefVisibility[monitor.id]\">{{monitorRefVisibility[monitor.id]?'Show All Objectives':'Show Only Applicable Objectives'}}</button-->\n" +
    "                  </div>\n" +
    "                </div>\n" +
    "                <span ng-repeat=\"goal in goals\">\n" +
    "                  <span ng-repeat=\"objective in goal.objectives\" ng-init=\"monitorRef=getMonitorRef(objective,monitor);\">\n" +
    "                  <div class=\"well monitor-objective-well\" ng-if=\"!monitorRefVisibility[monitor.id] || monitorRef.applicable\">\n" +
    "                    <div class=\"row\">\n" +
    "                      <div class=\"col-xs-2 monitor-controls\">\n" +
    "                        <div class=\"is-appplicable btn-group\">\n" +
    "                            <label class=\"no btn btn-default btn-xs\" ng-model=\"monitorRef.applicable\" uib-btn-radio=\"false\" ng-change=\"changeApplicability(objective,monitorRef)\"></label>\n" +
    "                            <label class=\"yes btn btn-default btn-xs\" ng-model=\"monitorRef.applicable\" uib-btn-radio=\"true\" ng-change=\"changeApplicability(objective,monitorRef)\"></label>\n" +
    "                        </div>\n" +
    "                      </div>\n" +
    "                      <div class=\"col-xs-10\">\n" +
    "                        <a href class=\"not-a-link monitor-goal-info\"\n" +
    "                             popover-title=\"Management Topic: {{objective.$sourceLabel||'?'}}\"\n" +
    "                             uib-popover=\"Goal: {{goal.description||goal.$description}}\"\n" +
    "                             popover-placement=\"bottom\"\n" +
    "                             popover-trigger=\"'mouseenter'\">\n" +
    "                          <label>Management Topic:</label> {{objective.$sourceLabel||'?'}} <label>&gt; Goal:</label> {{(goal.description||goal.$description) | ellipses}}\n" +
    "                        </a>\n" +
    "                        <div class=\"monitor-objective-info\">\n" +
    "                          <label>Objective:</label> {{objective.description}}\n" +
    "                        </div>\n" +
    "                      </div>\n" +
    "                    </div>\n" +
    "                  </div>\n" +
    "                  </span>\n" +
    "              </span>\n" +
    "              </span>\n" +
    "\n" +
    "            </niacs-title-panel>\n" +
    "\n" +
    "            <button class=\"btn btn-default niacs-btn-action niacs-right\" ng-click=\"addMonitoringPlan()\">Add {{project.monitor.length ? 'Another' : 'A'}} Monitoring Variable <fa-icon icon=\"plus-circle\"></fa-icon></button>\n" +
    "        </pane-set-left>\n" +
    "    </static-pane-set>\n" +
    "</div>\n" +
    "");
}]);

angular.module("partials/overview.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("partials/overview.html",
    "<pane-set unique-id=\"overview\">\n" +
    "    <pane-set-header>\n" +
    "        <div ng-controller=\"JustProjectCtrl\" class=\"pane-set-title\" title=\"Progress summary for {{project.label}}\"></div>\n" +
    "    </pane-set-header>\n" +
    "    <pane-set-footer>\n" +
    "        <niacs-navigation></niacs-navigation>\n" +
    "    </pane-set-footer>\n" +
    "\n" +
    "    <!-- STEP 1 -->\n" +
    "    <pane unique-id=\"overview.1\" pane-open=\"true\">\n" +
    "        <div id=\"unitOverview\" ng-controller=\"UnitsCtrl\">\n" +
    "            <pane-title title=\"Step 1. DEFINE areas of interest, management goals and objectives.\"\n" +
    "                        banner=\"{{project.units ? project.units.length : 0}} Management Topics | {{project | goalObjectiveCount:true}}\"\n" +
    "                        status=\"{{project | step1Completeness:'ab'}}\"></pane-title>\n" +
    "\n" +
    "            <niacs-title-panel unique-id=\"overview_1a\" type=\"l2\"\n" +
    "                                panel-title=\"{{'units' | stepLabel}}\"\n" +
    "                                panel-banner-status=\"{{project | step1Completeness:'a'}}\"\n" +
    "                                panel-banner=\"{{project.units ? project.units.length : 0}} Management Topics\">\n" +
    "              <table class=\"table table-condensed\">\n" +
    "                <tbody>\n" +
    "                    <tr ng-repeat=\"unit in project.units\"\n" +
    "                        uib-popover=\"{{(unit.description||unit.$description) | mightBeEmpty:'<No Description>'}}\"\n" +
    "                        popover-placement=\"bottom\"\n" +
    "                        popover-trigger=\"'mouseenter'\">\n" +
    "                        <td>{{unit.label||unit.$label}}</td>\n" +
    "                    </tr>\n" +
    "                </tbody>\n" +
    "              </table>\n" +
    "            </niacs-title-panel>\n" +
    "\n" +
    "            <niacs-title-panel unique-id=\"overview_1b\" type=\"l2\" panel-title=\"{{'goals' | stepLabel}}\"\n" +
    "                                panel-banner-status=\"{{project | step1Completeness:'b'}}\"\n" +
    "                                panel-banner=\"{{project | goalObjectiveCount:true}}\">\n" +
    "              <table class=\"table table-condensed\">\n" +
    "                <thead><tr><th>Management Topic</th><th>&nbsp;</th><th>&nbsp;</th></tr></thead>\n" +
    "                <tbody ng-repeat=\"context in contexts\" ng-if=\"context.id !== project.id\">\n" +
    "                    <tr class=\"active-tr\"\n" +
    "                        ng-click=\"context.$showGOOverview=!context.$showGOOverview\"\n" +
    "                        ng-class=\"{danger: (!allGoalsHaveObjectives(context))}\">\n" +
    "                        <td>\n" +
    "                            {{context | unitLabel:project}}\n" +
    "                        </td>\n" +
    "                        <td>{{context | goalObjectiveCount:false}}</td>\n" +
    "                        <td><font-awesome-action action=\"visit('goals','goals.'+context.id)\" icon=\"pencil\" size=\"1\"></font-awesome-action></td>\n" +
    "                    </tr>\n" +
    "                    <tr ng-show=\"context.$showGOOverview\">\n" +
    "                        <td colspan=\"3\">\n" +
    "                            <ul class=\"list-group\">\n" +
    "                                <li class=\"list-group-item\" ng-if=\"!context.goals.length\"><h5>No Goals/Objectives</h5></li>\n" +
    "                                <li class=\"list-group-item\" ng-repeat=\"goal in context.goals | inflate:project.goals:true\"><label>Goal:</label> {{(goal.description||goal.$description)  | mightBeEmpty}}\n" +
    "                                    <ul class=\"list-unstyled objectives\" ng-if=\"goal.objectives.length\">\n" +
    "                                      <li ng-repeat=\"objective in goal.objectives\"><label>Objective:</label> {{objective.description | mightBeEmpty}}<span ng-show=\"objective.timeframe\"> ({{objective.timeframe}})</span></li>\n" +
    "                                    </ul>\n" +
    "                                </li>\n" +
    "                            </ul>\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                </tbody>\n" +
    "              </table>\n" +
    "            </niacs-title-panel>\n" +
    "        </div>\n" +
    "    </pane>\n" +
    "    <!-- STEP 2 -->\n" +
    "    <pane unique-id=\"overview.2\">\n" +
    "        <div id=\"impactsOverview\" ng-controller=\"ImpactsCtrl\">\n" +
    "            <pane-title title=\"Step 2. ASSESS climate change impacts and vulnerabilities for the area of interest.\"\n" +
    "                        banner=\"Identified {{project | countClimateImpacts:true}} Potential Climate Impacts |\n" +
    "                        Determined {{project | countVulnerabilityDeterminations}} of {{contexts.length-1}} vulnerabilities\"\n" +
    "                        status=\"{{project | step2Completeness:'ab'}}\"></pane-title>\n" +
    "            <niacs-title-panel unique-id=\"overview_2a\" type=\"l2\" panel-title=\"{{'impacts' | stepLabel}}\"\n" +
    "                   panel-banner-status=\"{{project | step2Completeness:'a'}}\"\n" +
    "                   panel-banner=\"Identified {{project | countClimateImpacts:true}} Potential Climate Impacts\">\n" +
    "              <table class=\"table table-condensed\">\n" +
    "                <thead><tr><th>Management Topic</th><th>&nbsp;</th><th>&nbsp;</th></tr></thead>\n" +
    "                <tbody ng-repeat=\"context in contexts\">\n" +
    "                    <tr class=\"active-tr\"\n" +
    "                        ng-click=\"context.$showCISOverview=!context.$showCISOverview\"\n" +
    "                        ng-init=\"cisCount=niacs.countClimateImpacts(context)\"\n" +
    "                        ng-class=\"{danger: (cisCount==0)}\">\n" +
    "                        <td>\n" +
    "                            {{context | unitLabel:project}}\n" +
    "                        </td>\n" +
    "                        <td>Identified {{context | countClimateImpacts}} Potential Climate Impacts</td>\n" +
    "                        <td><font-awesome-action action=\"visit('impacts','impacts.'+context.id)\" icon=\"pencil\" size=\"1\"></font-awesome-action></td>\n" +
    "                    </tr>\n" +
    "                    <tr ng-show=\"context.$showCISOverview\">\n" +
    "                        <td colspan=\"3\">\n" +
    "                            <!-- this is pretty much the re-cap body cut/paste -->\n" +
    "                            <ul class=\"list-group\">\n" +
    "                                <li class=\"list-group-item\" ng-if=\"!context.cistatements.length\"><h5>No Identified Climate Impact Statements</h5></li>\n" +
    "                                <li class=\"list-group-item\" ng-repeat=\"statement in (context.cistatements | inflate:((context.id==project.id)?project.$vuln_region.$cistatements:context.$cistatements))\">\n" +
    "                                    <a href class=\"not-a-link\" ng-if=\"statement.label\"\n" +
    "                                            popover-title=\"Custom Climate Impact Statement\"\n" +
    "                                            uib-popover=\"{{statement.statement}}\"\n" +
    "                                            popover-placement=\"bottom\"\n" +
    "                                            popover-trigger=\"'mouseenter'\">{{statement.label}}</a>\n" +
    "                                    <a href class=\"not-a-link\" ng-if=\"!statement.label\"\n" +
    "                                            popover-title=\"Evidence: {{statement.$evidence}} | Agreement: {{statement.$agreement}}\"\n" +
    "                                            uib-popover=\"{{statement.$statement}}\"\n" +
    "                                            popover-placement=\"bottom\"\n" +
    "                                            popover-trigger=\"'mouseenter'\">{{statement.$label}}</a>\n" +
    "                                </li>\n" +
    "                            </ul>\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                </tbody>\n" +
    "              </table>\n" +
    "            </niacs-title-panel>\n" +
    "\n" +
    "            <niacs-title-panel\n" +
    "                   unique-id=\"overview_2b\" type=\"l2\"\n" +
    "                   panel-banner-status=\"{{project | step2Completeness:'b'}}\"\n" +
    "                   panel-banner=\"Determined {{project | countVulnerabilityDeterminations}} of {{vuln_contexts.length}} vulnerabilities\"\n" +
    "                   panel-title=\"{{'vulnerability' | stepLabel}}\">\n" +
    "              <table class=\"table table-condensed\">\n" +
    "                <thead><tr><th>Management Topic</th><th>Vulnerability Determination</th><th>&nbsp;</th></tr></thead>\n" +
    "                <tbody ng-repeat=\"context in contexts\" ng-if=\"$index > 0\">\n" +
    "                    <tr ng-class=\"{danger: (!context.vulnerability)}\">\n" +
    "                        <td>\n" +
    "                            {{context | unitLabel:project}}\n" +
    "                        </td>\n" +
    "                        <td ng-bind-html=\"context.vulnerability | vulnerabilityDetermination:vocab_vulnerability\"></td>\n" +
    "                        <td><font-awesome-action action=\"visit('vulnerability','vulnerability.'+context.id)\" icon=\"pencil\" size=\"1\"></font-awesome-action></td>\n" +
    "                    </tr>\n" +
    "                </tbody>\n" +
    "              </table>\n" +
    "            </niacs-title-panel>\n" +
    "        </div>\n" +
    "    </pane>\n" +
    "\n" +
    "    <!-- STEP 3 -->\n" +
    "    <pane unique-id=\"overview.3\">\n" +
    "        <div id=\"evaluateOverview\" ng-controller=\"EvaluateCtrl\">\n" +
    "            <pane-title title=\"Step 3. EVALUATE management objectives given projected impacts and vulnerabilities.\"\n" +
    "                        banner=\"{{project | objectEvaluateBanner:true}}\"\n" +
    "                        status=\"{{project | step3Completeness:true}}\"></pane-title>\n" +
    "\n" +
    "            <niacs-title-panel unique-id=\"overview_3a\" type=\"l2\" panel-title=\"{{'evaluate' | stepLabel}}\"\n" +
    "                   panel-banner-status=\"{{project | step3Completeness:true}}\"\n" +
    "                   panel-banner=\"{{project | objectEvaluateBanner:true}}\">\n" +
    "              <table class=\"table table-condensed\">\n" +
    "                <thead><tr><th>Management Topic</th><th>&nbsp;</th><th>&nbsp;</th></tr></thead>\n" +
    "                <tbody ng-repeat=\"context in contexts\">\n" +
    "                    <tr ng-init=\"status=(context | step3Completeness:false)\"\n" +
    "                        ng-class=\"{danger: (status==niacs.INCOMPLETE || status==niacs.PARTIAL_COMPLETE)}\">\n" +
    "                        <td>\n" +
    "                            {{context | unitLabel:project}}\n" +
    "                        </td>\n" +
    "                        <td>{{context | objectEvaluateBanner:false}}</td>\n" +
    "                        <td><font-awesome-action ng-if=\"niacs.collectObjectives(context).length > 0\" action=\"overviewVisit(context)\" icon=\"pencil\" size=\"1\"></font-awesome-action></td>\n" +
    "                    </tr>\n" +
    "                </tbody>\n" +
    "              </table>\n" +
    "            </niacs-title-panel>\n" +
    "        </div>\n" +
    "    </pane>\n" +
    "\n" +
    "    <!-- STEP 4 -->\n" +
    "    <pane unique-id=\"overview.4\">\n" +
    "        <div id=\"identifyOverview\" ng-controller=\"ActionsCtrl\">\n" +
    "            <pane-title title=\"Step 4. IDENTIFY adaptation approaches and tactics for implementation.\"\n" +
    "                        banner=\"{{project | step4Banner}}\"\n" +
    "                        status=\"{{project | step4Completeness}}\"></pane-title>\n" +
    "\n" +
    "            <niacs-title-panel unique-id=\"overview_4a\" type=\"l2\"\n" +
    "                   panel-title=\"{{'actions' | stepLabel}}\"\n" +
    "                   panel-banner=\"{{project | step4Banner}}\"\n" +
    "                   panel-banner-status=\"{{project | step4Completeness}}\">\n" +
    "              <table class=\"table table-condensed\">\n" +
    "                <thead><tr><th>Objective</th><th>&nbsp;</th></tr></thead>\n" +
    "                <tbody ng-repeat=\"objective in niacs.collectObjectives(project,true)\">\n" +
    "                    <tr class=\"active-tr\"\n" +
    "                        ng-click=\"objective.$showTacticOverview=!objective.$showTacticOverview\"\n" +
    "                        ng-class=\"{danger: (!objective.tactics || objective.tactics.length == 0)}\"\n" +
    "                        uib-popover=\"{{objective.description}}\"\n" +
    "                        popover-placement=\"bottom\"\n" +
    "                        popover-trigger=\"'mouseenter'\">\n" +
    "                        <td>\n" +
    "                            {{objective.description | ellipses:80}}\n" +
    "                        </td>\n" +
    "                        <td style=\"min-width: 160px;\">\n" +
    "                            {{(objective.tactics && objective.tactics.length) ? objective.tactics.length : 0 }} applicable tactics.\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                    <tr ng-show=\"objective.$showTacticOverview\">\n" +
    "                        <td colspan=\"2\">\n" +
    "                            <ul class=\"list-group\">\n" +
    "                                <li class=\"list-group-item\" ng-if=\"!objective.tactics.length\">\n" +
    "                                    <font-awesome-action icon=\"pencil\" add-classes=\"niacs-right\" action=\"visit('actions',null)\" size=\"1\"></font-awesome-action>\n" +
    "                                    <h5>No applicable tactics.</h5></li>\n" +
    "                                <li class=\"list-group-item\" ng-repeat=\"ref in objective.tactics\" ng-init=\"tactic = niacs.findById(project.tactics,ref.id)\">\n" +
    "                                    <div class=\"row\">\n" +
    "                                      <div class=\"col-xs-12\">\n" +
    "                                        <font-awesome-action icon=\"pencil\" add-classes=\"niacs-right\" action=\"overviewTacticVisit(tactic)\" size=\"1\"></font-awesome-action>\n" +
    "                                        <div class=\"tactic-details-overview\">\n" +
    "                                            <tactic-details tactic=\"tactic\" full=\"true\" project=\"project\"></tactic-details>\n" +
    "                                        </div>\n" +
    "                                      </div>\n" +
    "                                    </div>\n" +
    "                                </li>\n" +
    "                            </ul>\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                </tbody>\n" +
    "              </table>\n" +
    "            </niacs-title-panel>\n" +
    "        </div>\n" +
    "    </pane>\n" +
    "\n" +
    "    <!-- step 5 -->\n" +
    "    <pane unique-id=\"overview.5\">\n" +
    "        <div id=\"monitorOverview\" ng-controller=\"MonitorCtrl\">\n" +
    "            <pane-title title=\"Step 5. MONITOR and evaluate effectiveness of implemented actions.\"\n" +
    "                        banner=\"{{project | objectMonitorBanner:true}}\"\n" +
    "                        status=\"{{project | step5Completeness:true}}\"></pane-title>\n" +
    "            <niacs-title-panel unique-id=\"overview_5a\" type=\"l2\" panel-title=\"{{'monitor' | stepLabel}}\"\n" +
    "                   panel-banner-status=\"{{project | step5Completeness:true}}\"\n" +
    "                   panel-banner=\"{{project | objectMonitorBanner:true}}\">\n" +
    "              <table class=\"table table-condensed\">\n" +
    "                <thead><tr><th>Management Topic</th><th>&nbsp;</th></tr></thead>\n" +
    "                <tbody ng-repeat=\"context in contexts\">\n" +
    "                    <tr ng-init=\"status=(context | step5Completeness:false)\"\n" +
    "                        ng-class=\"{danger: (status==niacs.INCOMPLETE || status==niacs.PARTIAL_COMPLETE)}\">\n" +
    "                        <td>\n" +
    "                            {{context | unitLabel:project}}\n" +
    "                        </td>\n" +
    "                        <td>{{context | objectMonitorBanner:false}}</td>\n" +
    "                    </tr>\n" +
    "                </tbody>\n" +
    "              </table>\n" +
    "            </niacs-title-panel>\n" +
    "        </div>\n" +
    "    </pane>\n" +
    "</pane-set>\n" +
    "");
}]);

angular.module("partials/popovers/unit-info.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("partials/popovers/unit-info.html",
    "<div>\n" +
    "    <p>{{unit.description||unit.$description}}</p>\n" +
    "    <ul class=\"list-unstyled\">\n" +
    "      <li ng-repeat=\"local in unit.$local_link\"><a target=\"local_evidence\" href=\"{{local.self}}\"><fa-icon icon=\"file-pdf\"></fa-icon> {{local.filename}}</a></li>\n" +
    "      <li ng-repeat=\"external in (unit.external_link||unit.$external_link)\"><a target=\"external_evidence\" href=\"{{external.url}}\"><fa-icon icon=\"link\"></fa-icon> {{external.title}}</a></li>\n" +
    "    </ul>\n" +
    "</div>\n" +
    "");
}]);

angular.module("partials/recommendations.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("partials/recommendations.html",
    "<div ng-controller=\"ActionsCtrl\">\n" +
    "    <pane-set unique-id=\"recommendations\" open-heading-cols=\"4\">\n" +
    "        <pane-set-header>\n" +
    "            <div class=\"pane-set-title\"\n" +
    "                title=\"Tactic Recommendations\"\n" +
    "                info-key=\"TOOLTIP_TACTIC_RECOMMENDED\"\n" +
    "                info-type=\"panel\"></div>\n" +
    "        </pane-set-header>\n" +
    "        <pane-set-footer>\n" +
    "            <niacs-navigation></niacs-navigation>\n" +
    "        </pane-set-footer>\n" +
    "\n" +
    "        <pane ng-if=\"objectiveCount == 0\" unique-id=\"no-objectives-recommendations\" heading-only>\n" +
    "            <pane-heading>\n" +
    "                Please define <a href=\"#goals/{{project.id}}\">Management goals and objectives</a>.\n" +
    "            </pane-heading>\n" +
    "        </pane>\n" +
    "\n" +
    "        <pane ng-repeat=\"context in contexts\" unique-id=\"tacticRecommendations.{{context.id}}\" ng-if=\"hasObjectivesWithTactics(context)\" pane-open=\"{{$first}}\">\n" +
    "            <pane-title title=\"{{context | unitLabel:project}}\"\n" +
    "                        banner=\"{{context | tacticRecommendationBanner}}\"></pane-title>\n" +
    "            <niacs-title-panel ng-repeat=\"objective in niacs.collectObjectives(context)\"\n" +
    "                               ng-if=\"objective.tactics.length\"\n" +
    "                               type=\"l2\"\n" +
    "                               unique-id=\"context.{{context.id}}.tacticRecommendations.{{objective.id}}\"\n" +
    "                               panel-title=\"Objective: {{objective.description}}\">\n" +
    "                <div class=\"well\" ng-repeat=\"tacticRef in objective.tactics | inflate:project.tactics:true\">\n" +
    "                    <div class=\"container-fluid\">\n" +
    "                        <div class=\"row\">\n" +
    "                            <div class=\"col-xs-9\">\n" +
    "                                <font-awesome-action icon=\"pencil\" add-classes=\"niacs-right\" action=\"overviewTacticVisit(tacticRef)\" icon-tooltip=\"Edit tactic\" icon-tooltip-placement=\"left\"></font-awesome-action>\n" +
    "                                <label class=\"clickable underline\" style=\"display: inline;\" ng-click=\"tacticDetailVisibility[tacticRef.id]=!tacticDetailVisibility[tacticRef.id]\">{{tacticRef.$tactical|mightBeEmpty:'&amp;lt;Empty&amp;gt;'}}</label>\n" +
    "                                <div ng-repeat=\"approach in tacticRef.$approaches\" class=\"strategy-approach\">\n" +
    "                                    <label>Strategy:</label> {{strategyName(approach.strategy)}}\n" +
    "                                    &gt; <label>Approach:</label> {{approachName(approach.strategy,approach.approach)}}\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                            <div class=\"col-xs-3\">\n" +
    "                              <div class=\"is-recommended btn-group-vertical\" ng-if=\"tacticRef.applicable\">\n" +
    "                                  <label class=\"yes btn btn-default btn-xs\" ng-model=\"tacticRef.recommended\" uib-btn-radio=\"true\" ng-change=\"changeRecommendation(tacticRef)\"></label>\n" +
    "                                  <label class=\"no btn btn-default btn-xs\" ng-model=\"tacticRef.recommended\" uib-btn-radio=\"false\" ng-change=\"changeRecommendation(tacticRef)\"></label>\n" +
    "                              </div>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                        <div class=\"row top-space\" ng-if=\"tacticRef.applicable && !tacticRef.recommended\">\n" +
    "                            <div class=\"col-xs-12\">\n" +
    "                                <textarea custom-placeholder=\"NOT_RECOMMENDED_TACTIC_COMMENT_PLACEHOLDER\"\n" +
    "                                          ng-model=\"tacticRef.comment\"\n" +
    "                                          ng-blur=\"changeRecommendation(tacticRef)\"\n" +
    "                                          class=\"msd-elastic\" ng-class=\"{empty: !tacticRef.comment}\"></textarea>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                        <div class=\"row top-space\" ng-if=\"tacticDetailVisibility[tacticRef.id]\">\n" +
    "                            <div class=\"col-xs-12 simple-rounded\">\n" +
    "                                <tactic-details tactic=\"niacs.findById(project.tactics,tacticRef.id)\"></tactic-details>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </niacs-title-panel>\n" +
    "        </pane>\n" +
    "    </pane-set>\n" +
    "</div>\n" +
    "");
}]);

angular.module("partials/units.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("partials/units.html",
    "<div ng-controller=\"UnitsCtrl\">\n" +
    "    <static-pane-set>\n" +
    "        <pane-set-header>\n" +
    "            <div class=\"pane-set-title\"\n" +
    "                title-key=\"UNITS_HEADER\"\n" +
    "                info-key=\"TOOLTIP_PW_UNITS\"\n" +
    "                info-type=\"panel\"></div>\n" +
    "        </pane-set-header>\n" +
    "        <pane-set-footer>\n" +
    "            <niacs-navigation></niacs-navigation>\n" +
    "        </pane-set-footer>\n" +
    "        <pane-set-left>\n" +
    "            <label class=\"general-header\"><custom-text key=\"UNITS_SUBHEADER\"></custom-text></label>\n" +
    "            <div class=\"well well-sm\" ng-repeat=\"unit in project.$vuln_region.$units | inUse:project.units\">\n" +
    "                <ul class=\"list-inline niacs-right\">\n" +
    "                    <li><font-awesome-action action=\"addUnit(unit)\" icon=\"plus-circle\" icon-tooltip=\"Add\"></font-awesome-action></li>\n" +
    "                </ul>\n" +
    "                <div class=\"iblock-wrapper\">\n" +
    "                    <label>{{unit.label}}</label>\n" +
    "                    <a href class=\"more-info\"\n" +
    "                        uib-popover-template=\"'partials/popovers/unit-info.html'\"\n" +
    "                        popover-placement=\"auto bottom\"\n" +
    "                        popover-append-to-body=\"true\"\n" +
    "                        popover-trigger=\"'mouseenter'\"></a>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <button class=\"btn btn-default niacs-btn-action btn-block\" ng-click=\"addCustomUnit();\"><custom-text key=\"UNITS_ADD_BUTTON\"></custom-text> <fa-icon icon=\"plus-circle\"></fa-icon></button>\n" +
    "        </pane-set-left>\n" +
    "        <pane-set-right>\n" +
    "            <label class=\"general-header\">My property or project area</label>\n" +
    "            <div class=\"well well-sm\" ng-repeat=\"unit in project.units | inflate:project.$vuln_region.$units\">\n" +
    "                <ul class=\"list-inline niacs-right\">\n" +
    "                    <li ng-if=\"niacs.isCustomObject(unit)\"><font-awesome-action action=\"editCustomUnit(unit);\" icon=\"pencil\" icon-tooltip=\"Edit\"></font-awesome-action></li>\n" +
    "                    <li><font-awesome-action action=\"removeUnit(unit)\" icon=\"times-circle\" icon-tooltip=\"Remove\"></font-awesome-action></li>\n" +
    "                </ul>\n" +
    "                <div class=\"iblock-wrapper\">\n" +
    "                    <label>{{unit.label||unit.$label}}</label>\n" +
    "                    <a href class=\"more-info\"\n" +
    "                        uib-popover-template=\"'partials/popovers/unit-info.html'\"\n" +
    "                        popover-placement=\"auto bottom\"\n" +
    "                        popover-append-to-body=\"true\"\n" +
    "                        popover-trigger=\"'mouseenter'\"></a>\n" +
    "                    <font-awesome-action ng-if=\"!unit.comments && unit.comments !== ''\" size=\"1\" icon=\"comment\" icon-tooltip=\"Add Comments\" action=\"startComments($index)\"></font-awesome-action>\n" +
    "                </div>\n" +
    "                <unit-comments unit=\"unit\" ng-if=\"unit.comments || unit.comments === ''\"></unit-comments>\n" +
    "            </div>\n" +
    "        </pane-set-right>\n" +
    "    </static-pane-set>\n" +
    "</div>\n" +
    "");
}]);

angular.module("partials/user-profile.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("partials/user-profile.html",
    "<div>\n" +
    "    <div class=\"uinfo name\">{{userProfile.full_name}}</div>\n" +
    "    <div class=\"uinfo org\">{{userProfile.org}}</div>\n" +
    "    <br />\n" +
    "    <div class=\"uinfo email\">{{userProfile.email}}</div>\n" +
    "    <br />\n" +
    "    <div class=\"uinfo contact\">You indicated that it {{userProfile.contact ? 'is' : 'is not'}} OK for NIACS to contact you</div>\n" +
    "    <br />\n" +
    "    <div class=\"uinfo membership\">Workbook user for {{userProfile.created | timestampReadableSince}}</div>\n" +
    "    <br />\n" +
    "    <font-awesome-action title=\"Edit account information\" icon=\"pencil\" action=\"editAccount()\"></font-awesome-action>\n" +
    "</div>\n" +
    "");
}]);

angular.module("partials/vulnerability.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("partials/vulnerability.html",
    "<div ng-controller=\"VulnerabilityCtrl\">\n" +
    "    <pane-set unique-id=\"vulnerability\" open-heading-cols=\"4\">\n" +
    "        <pane-set-header>\n" +
    "            <div class=\"pane-set-title\" title=\"Vulnerability Determination\" info-key=\"TOOLTIP_VULNERABILITY\" info-type=\"panel\"></div>\n" +
    "        </pane-set-header>\n" +
    "        <pane-set-footer>\n" +
    "            <niacs-navigation></niacs-navigation>\n" +
    "        </pane-set-footer>\n" +
    "\n" +
    "        <pane ng-if=\"!contexts.length\" unique-id=\"no-contexts-vulnerability\" heading-only>\n" +
    "            <pane-heading>\n" +
    "                Please complete <a href=\"#units/{{project.id}}\">Step 1.1</a>.\n" +
    "            </pane-heading>\n" +
    "        </pane>\n" +
    "\n" +
    "        <pane ng-repeat=\"context in contexts\" unique-id=\"vulnerability.{{context.id}}\" pane-open=\"{{$first}}\">\n" +
    "            <pane-title title=\"{{context | unitLabel:project}}\"\n" +
    "                        banner=\"<div>My vulnerability rating for this property: {{context.vulnerability | vulnerabilityDetermination:vocab_vulnerability}} {{context.$unit_vulnerability?'</div><div>Region-wide vulnerability: '+context.$unit_vulnerability:''}}</div>\"\n" +
    "                        status=\"{{context.vulnerability ? niacs.COMPLETE : niacs.INCOMPLETE}}\"></pane-title>\n" +
    "\n" +
    "            <niacs-recap-climate-impacts context=\"project\"\n" +
    "                statements=\"project.cistatements | inflate:project.$vuln_region.$cistatements\"\n" +
    "                panel-title=\"Review Potential Regional Climate Impacts\"\n" +
    "                info-icon-key=\"TOOLTIP_RECAP_REGIONAL_CLIMATE_IMPACTS\"></niacs-recap-climate-impacts>\n" +
    "            <niacs-recap-climate-impacts context=\"context\"\n" +
    "                panel-title=\"Review Potential {{context | unitLabel:project}} Climate Impacts\"\n" +
    "                statements=\"context.cistatements | inflate:((context.id==project.id)?project.$vuln_region.$cistatements:context.$cistatements)\"></niacs-recap-climate-impacts>\n" +
    "\n" +
    "            <div class=\"container-fluid\" ng-if=\"isAgriculture === false\">\n" +
    "              <div class=\"row\">\n" +
    "                <div class=\"col-xs-12\">\n" +
    "                    <h3 style=\"margin-top: 0px;\">Vulnerability Determination: <span ng-bind-html=\"context.vulnerability | vulnerabilityDetermination:vocab_vulnerability\"></span></h3>\n" +
    "                    <vulnerability-sliders target=\"context\"></vulnerability-sliders>\n" +
    "                </div>\n" +
    "              </div>\n" +
    "              <div class=\"row\" ng-show=\"context.vulnerability\">\n" +
    "                <div class=\"col-xs-12 vulnerability-determination-wrapper\">\n" +
    "                  <vulnerability-plot target=\"context\"></vulnerability-plot>\n" +
    "                </div>\n" +
    "              </div>\n" +
    "            </div>\n" +
    "\n" +
    "            <div class=\"container-fluid\" ng-if=\"isAgriculture === true\">\n" +
    "              <div class=\"row\">\n" +
    "                <div class=\"col-xs-12\">\n" +
    "                    <h3 style=\"margin-top: 0px;\">Vulnerability Determination: <span ng-bind-html=\"context.vulnerability | vulnerabilityDetermination:vocab_vulnerability\"></span></h3>\n" +
    "                    <vulnerability-sliders-ag target=\"context\"></vulnerability-sliders-ag>\n" +
    "                </div>\n" +
    "              </div>\n" +
    "            </div>\n" +
    "\n" +
    "        </pane>\n" +
    "    </pane-set>\n" +
    "</div>\n" +
    "");
}]);
